 import React from 'react'
import { useEffect, useState, useRef, createRef, useMemo, useCallback } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryGridAr from "../components/EntryGridAr";
import EntrySetting from "../components/EntrySetting";
import EntryRemarks from "../components/EntryRemarks";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntryBase from "../components/EntryBase";
import MDtounyuhyo, { isIssuedInputBlock, MD_INPUT_REQUIRED_FIELD_DEFS } from "./components/MDtounyuhyo";
import MDtounyuHinbanDialog from "./components/MDtounyuHinbanDialog";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { isEmpty, getglobaldata, CellType, Getstorage, Savestorage, DeepCopy, setglobaldata, getformid, getcontroller, getsubkey, initializedata, isEnabled } from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist } from '../modules/imagedlgstore';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption, reports, setchangeurl } from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';

ModuleRegistry.registerModules([
    AllEnterpriseModule,
    AllCommunityModule
]);

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

//動作抑止
const suppressaction = [
    { type: "0", action: "INSERT" },
    { type: "0", action: "UPDATE" },
    { type: "1", action: "INSERT" },
];

const CUSTOM_SECTION_KEY_BASICINFO = "__md_basicinfo_section__";
const CUSTOM_SECTION_KEYS = [CUSTOM_SECTION_KEY_BASICINFO];
const CUSTOM_SECTION_DOM_ID = {
    [CUSTOM_SECTION_KEY_BASICINFO]: "basicinfosectionpanel"
};
const SECTION_ORDER_STORAGE_SUFFIX = "sectionorder";
const BASIC_INFO_TAB_TYPE = {
    INPUT: "300",
    ORDER: "301",
    DELIVERY: "302"
};
const MDTOUNYU_ROOT_CLASS = "mdtounyu-root";
const MDTOUNYU_ENTRY_BODY_CLASS = "mdtounyu-entry-body";
const MATERIAL_GRID_CLASS = "mdtounyu-material-grid";
const MDTOUNYU_PRIMARY_KEY = "TNY_NO";
// 素材明細GRIDは行番号を業務上のA-D表記に置き換える。
const MATERIAL_GRID_ROW_LABELS = ["A", "B", "C", "D"];
const MATERIAL_GRID_ROW_LABEL_WIDTH = 56;
const MATERIAL_GRID_WIDTH_GUARD = 6;
// 発注元は企画元が未入力の間だけMD投入表側で入力不可にする。
const MD_KIKAKUMOTO_FIELD_KEYS = ["TNY_TonyuKikaMoto", "TNY_TONYUKIKAMOTO"];
const MD_HACHUMOTO_FIELD_KEYS = ["TNY_TonyuHatMoto", "TNY_TONYUHATMOTO"];
// 素材品名の自動補完で、行データからブランド/品番/仕入先を拾う候補列。
const MATERIAL_NAME_SOURCE_COLUMNS = [
    "TNYS_BRDCD",
    "ZAI_BRDCODE",
    "BRD_CODE",
    "BRD_CD",
    "TNYS_BRDCD_cd",
    "ZAI_BRDCODE_cd",
    "TNYS_ZAIHINBAN",
    "ZAI_HINBAN",
    "TNYS_ZAIHINBAN_cd",
    "ZAI_HINBAN_cd",
    "TNYS_ZAISIIRESAKICD",
    "ZAI_TORCODE",
    "TOR_CODE",
    "TNYS_ZAISIIRESAKICD_cd",
    "ZAI_TORCODE_cd",
    "TOR_CODE_cd"
];
const MATERIAL_COLOR_SOURCE_COLUMNS = [
    "TNYSH_COLORNO",
    "TNYSH_COLORNO_cd",
    "TNYSH_COLORCD",
    "TNYSH_COLORCD_cd",
    "ZAIC_COLORCD",
    "ZAIC_COLORCD_cd",
    "COLORCD",
    "COLORCD_cd",
    "COLOR_CODE",
    "COLORNO",
    "COLOR"
];
const MATERIAL_GRID_STYLE = `
    .${MDTOUNYU_ROOT_CLASS} .masterlayout-grid,
    .${MDTOUNYU_ROOT_CLASS} .${MDTOUNYU_ENTRY_BODY_CLASS},
    .${MATERIAL_GRID_CLASS} {
        contain: paint style;
        isolation: isolate;
    }
    .${MDTOUNYU_ROOT_CLASS} .masterlayout-grid .ag-root-wrapper,
    .${MDTOUNYU_ROOT_CLASS} .${MDTOUNYU_ENTRY_BODY_CLASS} .ag-root-wrapper {
        contain: paint;
    }
    .${MATERIAL_GRID_CLASS} {
        display: block;
        width: 100%;
        max-width: 100%;
        overflow-x: hidden;
        overflow-y: hidden;
    }
    .${MATERIAL_GRID_CLASS} > .ag-theme-balham {
        width: 100% !important;
        max-width: 100% !important;
        overflow: hidden !important;
    }
    .${MATERIAL_GRID_CLASS} .ag-root-wrapper,
    .${MATERIAL_GRID_CLASS} .ag-root,
    .${MATERIAL_GRID_CLASS} .ag-header,
    .${MATERIAL_GRID_CLASS} .ag-body,
    .${MATERIAL_GRID_CLASS} .ag-body-viewport,
    .${MATERIAL_GRID_CLASS} .ag-center-cols-viewport,
    .${MATERIAL_GRID_CLASS} .ag-center-cols-clipper {
        width: 100% !important;
        max-width: 100% !important;
        overflow-x: hidden !important;
    }
    .${MATERIAL_GRID_CLASS} .ag-body-horizontal-scroll,
    .${MATERIAL_GRID_CLASS} .ag-body-horizontal-scroll-viewport,
    .${MATERIAL_GRID_CLASS} .ag-body-horizontal-scroll-container,
    .${MATERIAL_GRID_CLASS} .ag-horizontal-left-spacer,
    .${MATERIAL_GRID_CLASS} .ag-horizontal-right-spacer {
        display: none !important;
        visibility: hidden !important;
        width: 0 !important;
        height: 0 !important;
        max-width: 0 !important;
        max-height: 0 !important;
        min-width: 0 !important;
        min-height: 0 !important;
        overflow: hidden !important;
    }
    .${MATERIAL_GRID_CLASS} .ag-header-cell[col-id="grip"],
    .${MATERIAL_GRID_CLASS} .ag-cell[col-id="grip"],
    .${MATERIAL_GRID_CLASS} .ag-header-cell[col-id="rowid"],
    .${MATERIAL_GRID_CLASS} .ag-cell[col-id="rowid"],
    .${MATERIAL_GRID_CLASS} .ag-header-cell[col-id="ag-Grid-ControlsColumn"],
    .${MATERIAL_GRID_CLASS} .ag-cell[col-id="ag-Grid-ControlsColumn"] {
        display: none !important;
        width: 0 !important;
        min-width: 0 !important;
        max-width: 0 !important;
        padding: 0 !important;
        border: none !important;
        margin: 0 !important;
        overflow: hidden !important;
    }
    .${MATERIAL_GRID_CLASS} .ag-row-number-header,
    .${MATERIAL_GRID_CLASS} .ag-row-number-cell {
        width: 56px !important;
        min-width: 56px !important;
        max-width: 56px !important;
    }
    .${MATERIAL_GRID_CLASS} .ag-row-number-header {
        background-color: #8fa7a0 !important;
        color: #ffffff !important;
    }
    .${MATERIAL_GRID_CLASS} .ag-row-number-cell {
        align-items: center;
        background-color: inherit !important;
        color: transparent !important;
        display: flex;
        font-size: 0 !important;
        font-weight: 600;
        justify-content: center;
        text-align: center;
    }
    .${MATERIAL_GRID_CLASS} .ag-row-number-cell::after {
        color: #243d6a !important;
        font-size: 12px;
        font-weight: 600;
    }
    .${MATERIAL_GRID_CLASS} .ag-row[row-index="0"] .ag-row-number-cell::after {
        content: "A";
    }
    .${MATERIAL_GRID_CLASS} .ag-row[row-index="1"] .ag-row-number-cell::after {
        content: "B";
    }
    .${MATERIAL_GRID_CLASS} .ag-row[row-index="2"] .ag-row-number-cell::after {
        content: "C";
    }
    .${MATERIAL_GRID_CLASS} .ag-row[row-index="3"] .ag-row-number-cell::after {
        content: "D";
    }
`;
const AGFunc = React.forwardRef(AGFunction);
const ComFunc = React.forwardRef(ComFunction);
const CELLTYPE = CellType();

// 素材明細GRIDの幅補正を開発時に一時停止するための切り分け用スイッチ。
function isMaterialGridLayoutFixDisabled() {
    return process.env.NODE_ENV === 'development'
        && typeof window !== 'undefined'
        && window.localStorage
        && window.localStorage.getItem('mdtounyuDisableMaterialGridLayoutFix') === '1';
}

// MasterLayoutのメニュー開閉ではprops.childrenも再評価されるため、
// MD投入表の重い入力フォーム本体はMD側で生成済みの要素を使い回す。
const MemoizedEntryForm = React.memo(function MemoizedEntryForm({ content }) {
    return content;
});

const EntryFormContent = React.memo(function EntryFormContent({
    entryBodyRef,
    onDragEnter,
    sections,
    renderSection
}) {
    return (
        <div
            className={MDTOUNYU_ENTRY_BODY_CLASS}
            style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }}
            ref={entryBodyRef}
            onDragEnter={onDragEnter}
        >
            {sections.map(renderSection)}
        </div>
    );
}, function (prev, next) {
    return prev.sections === next.sections
        && prev.renderSection === next.renderSection
        && prev.entryBodyRef === next.entryBodyRef
        && prev.onDragEnter === next.onDragEnter;
});

// 基本情報3タブの空データ雛形を返す。
function emptyTabBaseInfo() {
    return { input: {}, order: {}, delivery: {} };
}
// API返却の基本情報3タブデータを正規化する。
function resolveTabBaseInfo(source) {
    if (isEmpty(source)) return emptyTabBaseInfo();
    return {
        input: source.input || {},
        order: source.order || {},
        delivery: source.delivery || {}
    };
}
// JSON文字列または配列を安全に配列へ変換する。
function parseJsonArray(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'string' && value.trim() !== '') {
        try {
            const parsed = JSON.parse(value);
            if (Array.isArray(parsed)) return parsed;
        } catch {
            return [];
        }
    }
    return [];
}

// 登録エラーを見出し＋詳細の配列へ整形し、警告ダイアログで行ごとに表示する。
function buildRegistrationWarningLines(title, detail) {
    const heading = String(title || '').trim();
    const lines = heading === '' ? [] : [heading];
    const values = Array.isArray(detail) ? detail : [detail];
    const headingKey = heading.replace(/[\s。]/g, '');
    values.forEach((value) => {
        String(value === null || value === undefined ? '' : value)
            .split(/\r\n|\n/)
            .map((line) => line.trim())
            .filter((line) => line !== '')
            .forEach((line) => {
                if (line.replace(/[\s。]/g, '') === headingKey) return;
                lines.push(line);
            });
    });
    return lines;
}

// 投入数タブのブロック配列を取得する。
function resolveInputBlocks(source) {
    const info = resolveTabBaseInfo(source);
    return parseJsonArray(info.input ? info.input._INPUT_BLOCKS : null);
}

// 投入表情報セクションの項目かを物理テーブル名で判定する。
function isMdTnyHeaderField(field) {
    if (!field || typeof field !== 'object') return false;
    const table = String(field.table || '').trim().split(/\s+/)[0].split('.').pop();
    return String(table || '').toUpperCase() === 'D_TNY';
}

// s_logp設定で出したGRIDのうち、素材明細セクションだけに独自装飾を当てる。
function isMaterialDetailGridPanel(panel) {
    if (isEmpty(panel) || !panel.grid) return false;
    const panelName = [panel.name, panel.name2].map((value) => String(value || '')).join(' ');
    return panelName.indexOf('素材明細') !== -1;
}

// 素材明細の見出しはname/name2の両方を考慮して組み立てる。
function getMaterialPanelTitle(panel) {
    if (isEmpty(panel)) return '';
    const name = String(panel.name || '').trim();
    const name2 = String(panel.name2 || '').trim();
    return name2 === '' ? name : `${name} ${name2}`;
}

// AG Gridの行番号機能を使い、1-4ではなくA-Dの固定ラベルとして表示する。
function buildMaterialGridRowNumbersOptions() {
    return {
        width: MATERIAL_GRID_ROW_LABEL_WIDTH,
        minWidth: MATERIAL_GRID_ROW_LABEL_WIDTH,
        maxWidth: MATERIAL_GRID_ROW_LABEL_WIDTH,
        resizable: false,
        suppressCellSelectionIntegration: true,
        headerStyle: {
            backgroundColor: "#8fa7a0",
            color: "#ffffff"
        },
        valueGetter: function (params) {
            const index = isEmpty(params) || isEmpty(params.node) ? -1 : params.node.rowIndex;
            if (index < 0 || index >= MATERIAL_GRID_ROW_LABELS.length) return '';
            return MATERIAL_GRID_ROW_LABELS[index];
        }
    };
}

// GRID生成後に行番号オプションを差し込み、設定GRIDでもA-D表示を維持する。
function applyMaterialGridRowNumbers(param) {
    if (isMaterialGridLayoutFixDisabled()) return;
    const api = !isEmpty(param) && !isEmpty(param.api) ? param.api : param;

    try {
        if (!isEmpty(api) && !isEmpty(api.setGridOption)) {
            api.setGridOption('rowNumbers', buildMaterialGridRowNumbersOptions());
            api.setGridOption('suppressHorizontalScroll', true);
            api.setGridOption('suppressColumnVirtualisation', false);
        }
    } catch {
    }
}

function isMaterialGridSystemColumnId(id) {
    return id === 'grip'
        || id === 'rowid'
        || id === 'ag-Grid-ControlsColumn'
        || id === 'ag-Grid-RowNumbersColumn'
        || id === 'ag-Grid-RowNumberColumn'
        || id === 'ag-Grid-SelectionColumn'
        || id === 'ag-Grid-AutoColumn';
}

function materialGridColumnId(column) {
    if (isEmpty(column)) return '';
    try {
        if (!isEmpty(column.getColId)) return String(column.getColId());
        if (!isEmpty(column.colId)) return String(column.colId);
        const colDef = !isEmpty(column.getColDef) ? column.getColDef() : column.colDef || column;
        if (!isEmpty(colDef.colId)) return String(colDef.colId);
        if (!isEmpty(colDef.field)) return String(colDef.field);
    } catch {
    }
    return '';
}

function materialGridColumnDef(column) {
    if (isEmpty(column)) return {};
    try {
        if (!isEmpty(column.getColDef)) return column.getColDef() || {};
        return column.colDef || column;
    } catch {
        return {};
    }
}

function materialGridColumnVisible(column) {
    if (isEmpty(column)) return false;
    const colDef = materialGridColumnDef(column);
    try {
        if (!isEmpty(column.isVisible) && !column.isVisible()) return false;
    } catch {
    }
    return colDef.hide !== true && colDef.initialHide !== true;
}

function materialGridColumnWidth(column) {
    const colDef = materialGridColumnDef(column);
    let width = 0;
    try {
        if (!isEmpty(column.getActualWidth)) width = Number(column.getActualWidth());
        else if (!isEmpty(column.actualWidth)) width = Number(column.actualWidth);
    } catch {
        width = 0;
    }
    if (!Number.isNaN(width) && width > 0) return width;

    width = Number(colDef.width || colDef.initialWidth || colDef.minWidth || 80);
    if (!Number.isNaN(width) && width > 0) return width;
    return 80;
}

function materialGridColumns(api, extraColumnDefs) {
    if (isEmpty(api)) return [];

    const result = [];
    const seen = {};
    const appendColumns = function (columns) {
        (Array.isArray(columns) ? columns : []).forEach((column) => {
            const id = materialGridColumnId(column);
            if (id === '' || isMaterialGridSystemColumnId(id) || seen[id]) return;
            if (!materialGridColumnVisible(column)) return;
            seen[id] = true;
            result.push(column);
        });
    };

    try {
        if (!isEmpty(api.getAllDisplayedColumns)) appendColumns(api.getAllDisplayedColumns());
    } catch {
    }
    try {
        if (!isEmpty(api.getAllGridColumns)) appendColumns(api.getAllGridColumns());
    } catch {
    }
    try {
        if (!isEmpty(api.getColumns)) appendColumns(api.getColumns());
    } catch {
    }
    try {
        if (!isEmpty(api.getColumnDefs)) appendColumns(api.getColumnDefs());
    } catch {
    }

    // AG Grid APIから右端列が漏れるケースに備え、EntryGridArが保持する設定列でも補完する。
    appendColumns(extraColumnDefs);

    if (result.length === 0) {
        try {
            if (!isEmpty(api.getColumnDefs)) appendColumns(api.getColumnDefs());
        } catch {
        }
    }
    return result;
}

function isMdMainMenuOpen() {
    if (typeof document === "undefined") return false;
    const panel = document.getElementById("menupanel");
    return !isEmpty(panel) && !isEmpty(panel.querySelector(".MuiDrawer-paper"));
}

// 素材明細GRIDの再レイアウト要否判定キー。列/行/表示幅が同じなら重い補正処理を省略する。
function materialGridLayoutSignature(api, gridElement, columnDefs) {
    try {
        const columns = materialGridColumns(api, columnDefs);
        const columnIds = columns.map((column) => materialGridColumnId(column)).join(",");
        const rowCount = !isEmpty(api) && !isEmpty(api.getDisplayedRowCount) ? api.getDisplayedRowCount() : 0;
        const wrapper = !isEmpty(gridElement) && !isEmpty(gridElement.closest)
            ? gridElement.closest(`.${MATERIAL_GRID_CLASS}`)
            : null;
        const viewWidth = wrapper ? wrapper.clientWidth : (gridElement ? gridElement.clientWidth : 0);
        return `${columnIds}|${rowCount}|${viewWidth}`;
    } catch {
        return "";
    }
}

// 値の長さに合わせて列幅を自動調整し、素材明細の横方向の詰まりを抑える。
function autoSizeMaterialGridColumns(api, columnDefs) {
    if (isEmpty(api) || isEmpty(api.autoSizeColumns)) return;

    try {
        const columns = materialGridColumns(api, columnDefs);
        if (!Array.isArray(columns)) return;

        const columnIds = columns
            .map((column) => materialGridColumnId(column))
            .filter((id) => id !== '' && !isMaterialGridSystemColumnId(id));

        if (columnIds.length === 0) return;
        api.autoSizeColumns(columnIds, false);
    } catch {
    }
}

// 設定GRID由来の行入替/rowid等のシステム列を素材明細では非表示にする。
function hideMaterialGridSystemColumns(param) {
    const api = !isEmpty(param) && !isEmpty(param.api) ? param.api : param;
    const columnApi = !isEmpty(param) && !isEmpty(param.columnApi) ? param.columnApi : null;

    applyMaterialGridRowNumbers(api);
    try {
        // 旧AG Grid API互換: columnApiが渡る場合はこちらで非表示指定する。
        if (!isEmpty(columnApi) && !isEmpty(columnApi.applyColumnState)) {
            columnApi.applyColumnState({
                state: [
                    { colId: 'grip', hide: true },
                    { colId: 'rowid', hide: true },
                    { colId: 'ag-Grid-ControlsColumn', hide: true }
                ]
            });
        }
    } catch {
    }
    try {
        // 新AG Grid API互換: api側に列状態操作がある場合はこちらで非表示指定する。
        if (!isEmpty(api) && !isEmpty(api.applyColumnState)) {
            api.applyColumnState({
                state: [
                    { colId: 'grip', hide: true },
                    { colId: 'rowid', hide: true },
                    { colId: 'ag-Grid-ControlsColumn', hide: true }
                ]
            });
        }
    } catch {
    }
}

// 初期列定義作成時にもシステム列を落とし、描画直後の一瞬表示を減らす。
function MaterialGridQuerySetColumn(colDef) {
    if (!Array.isArray(colDef) || colDef.length === 0) return colDef;

    return colDef.filter(function (column) {
        if (isEmpty(column)) return false;
        const id = String(column.colId || column.field || '');
        return id !== 'grip'
            && id !== 'rowid'
            && id !== 'ag-Grid-ControlsColumn';
    }).map(function (column) {
        const next = { ...column };
        // 素材明細は横スクロールを出さず全列を表示するため、列ごとの固定幅抑止を外す。
        delete next.suppressSizeToFit;
        delete next.flex;
        if (isEmpty(next.minWidth)) next.minWidth = 50;
        return next;
    });
}

// 文字列/空値を安全に数値へ変換する。数量集計でNaNを広げないための共通処理。
function toNum(value) {
    if (value === null || value === undefined || value === '') return NaN;
    const num = Number(String(value).replace(/,/g, ''));
    return Number.isNaN(num) ? NaN : num;
}

// 投入ブロックに格納されたカラーサイズ行(JSON/配列)を配列へ戻す。
function parseBlockQtyRows(block) {
    return parseJsonArray(block ? block._QTY_ROWS : null);
}

// サイズ・カラー明細から投入数合計を算出する。
// 投入ブロックの数量明細から合計値を算出する。
function getBlockInputQtyTotal(block) {
    const rows = parseBlockQtyRows(block);
    let total = 0;
    let hasValue = false;
    rows.forEach((row) => {
        const values = Array.isArray(row && row.values)
            ? row.values.map((item) => item ? item.qty : '')
            : Object.keys((row && row.values) || {}).map((k) => row.values[k]);
        values.forEach((qty) => {
            const num = toNum(qty);
            if (!Number.isNaN(num)) {
                total += num;
                hasValue = true;
            }
        });
    });
    return hasValue ? total : 0;
}

// サイズ・カラー展開済みかを判定する。
// カラーサイズ表を表示する価値があるデータかを判定する。
function hasColorSizeData(block) {
    const rows = parseBlockQtyRows(block);
    return rows.some((row) => {
        const color = row && row.color ? String(row.color).trim() : '';
        if (color === '') return false;
        const values = Array.isArray(row.values)
            ? row.values
            : Object.keys((row && row.values) || {}).map((k) => ({ size: k, qty: row.values[k] }));
        return values.some((item) => item && String(item.size || '').trim() !== '');
    });
}

// 数量表示は整数なら小数を落とし、端数がある場合だけ小数表示にする。
function formatQtyText(value) {
    if (Number.isNaN(value)) return '';
    if (Number.isInteger(value)) return String(value);
    return String(Number(value.toFixed(4)));
}

// 受注数カードを投入数下段表示用のサイズ/カラー行列へ変換する。
// 受注/投入データをカラー x サイズのマトリクスへ変換する。
function buildQtyMatrixFromOrderCard(card) {
    const groups = Array.isArray(card && card.groups) ? card.groups : [];
    const sizeOrder = [];
    const colorOrder = [];
    const colorSizeMap = new Map();

    groups.forEach((group) => {
        const color = String(group && group.color ? group.color : '').trim();
        if (!colorSizeMap.has(color)) {
            colorSizeMap.set(color, new Map());
            colorOrder.push(color);
        }
        const sizeMap = colorSizeMap.get(color);
        const rows = Array.isArray(group && group.rows) ? group.rows : [];
        rows.forEach((row) => {
            const size = String(row && row.size ? row.size : '').trim();
            if (size === '') return;
            if (sizeOrder.indexOf(size) === -1) sizeOrder.push(size);
            const qty = toNum(row ? row.qty : '');
            if (Number.isNaN(qty)) return;
            sizeMap.set(size, (sizeMap.get(size) || 0) + qty);
        });
    });

    const rows = colorOrder.map((color) => {
        const sizeMap = colorSizeMap.get(color) || new Map();
        const values = sizeOrder.map((size) => ({
            size: size,
            qty: sizeMap.has(size) ? formatQtyText(sizeMap.get(size)) : ''
        }));
        const rowTotal = sizeOrder.reduce((sum, size) => sum + (sizeMap.get(size) || 0), 0);
        const hasValue = sizeOrder.some((size) => sizeMap.has(size));
        return {
            color: color,
            values: values,
            total: hasValue ? formatQtyText(rowTotal) : ''
        };
    });

    const totals = sizeOrder.map((size) => {
        let sum = 0;
        let hasValue = false;
        colorOrder.forEach((color) => {
            const sizeMap = colorSizeMap.get(color);
            if (!sizeMap || !sizeMap.has(size)) return;
            sum += sizeMap.get(size);
            hasValue = true;
        });
        return { size: size, qty: hasValue ? formatQtyText(sum) : '' };
    });

    const grandTotal = totals.reduce((sum, item) => {
        const num = toNum(item ? item.qty : '');
        return Number.isNaN(num) ? sum : sum + num;
    }, 0);
    const hasGrandTotal = totals.some((item) => !Number.isNaN(toNum(item ? item.qty : '')));
    const totalM = totals.find((item) => String(item && item.size ? item.size : '').toUpperCase() === 'M');
    const totalL = totals.find((item) => String(item && item.size ? item.size : '').toUpperCase() === 'L');

    return {
        sizes: sizeOrder,
        rows: rows,
        totals: totals,
        totalM: totalM ? totalM.qty : '',
        totalL: totalL ? totalL.qty : '',
        grandTotal: hasGrandTotal ? formatQtyText(grandTotal) : ''
    };
}

export const MDtounyu = props => {

    const panelsdef = [];
    const G_id = { BASE: "0", IMAGE: "pic", FILE: "file", NB: "nb", PL:"pl"}
    const formid = getformid("MDtounyu", props.location.search);
    const controller = getcontroller("MDtounyu", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const user = useSelector(state => state.user, shallowEqual);
    const menuMenus = useSelector(state => state.menu.menus, shallowEqual);
    const menudata = useMemo(() => ({ menus: Array.isArray(menuMenus) ? menuMenus : [] }), [menuMenus]);
    const menuCtrls = useSelector(state => state.form.menuinfo ? state.form.menuinfo.ctrls : [], shallowEqual);
    const changeurl = useSelector(state => state.form.changeurl, shallowEqual);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et, shallowEqual);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et, shallowEqual);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const themeStyle = useSelector(state => state.form.themestyle, shallowEqual);

    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const locationstate = useRef(null);    //遷移State
    const reportsRef = useRef([]);
    const listRoutingChangeUrlBackupRef = useRef([]);
    const listRoutingInitializedRef = useRef(false);
    const materialNameRequestRef = useRef({});
    const materialGridLayoutStateRef = useRef({});
    const materialGridLayoutRafRef = useRef({});
    const hachuMotoOriginalLockedRef = useRef({});
    const hachuMotoDynamicLockedRef = useRef({});

    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [sectionOrder, setsectionOrder] = useState([]);
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [primarykeys, setprimarykeys] = useState([]);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [baseinfo, setbaseinfo] = useState({});
    const [tabBaseInfo, settabBaseInfo] = useState({ input: {}, order: {}, delivery: {} });
    const inputBlocksStateRef = useRef([]);
    const [basicInfoTab, setbasicInfoTab] = useState('input');
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [update, setUpdata] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);
    const [hinbanDialogOpen, setHinbanDialogOpen] = useState(false);
    const [hinbanDialogInitialValues, setHinbanDialogInitialValues] = useState(null);
    const [pendingOrderLaunches, setPendingOrderLaunches] = useState([]);
    const gridlist = useSelector(state => state.form.gridlist, shallowEqual);

    // 発注済み加工指示が1件でもある既存投入表では、投入表情報の備考以外を入力不可にする。
    const hasIssuedInputBlock = useMemo(
        () => resolveInputBlocks(tabBaseInfo).some((block) => isIssuedInputBlock(block)),
        [tabBaseInfo]
    );
    const lockIssuedEntryData = formstatus === 'ENTRY FORM' && hasIssuedInputBlock;
    const effectiveTextfields = useMemo(() => {
        if (!lockIssuedEntryData) return textfields;
        return textfields.map((field) => {
            if (!isMdTnyHeaderField(field)) return field;
            if (String(field.columnid || '').toUpperCase() === 'TNY_BIKO') return field;
            if (field.locked) return field;
            return { ...field, locked: true };
        });
    }, [textfields, lockIssuedEntryData]);

    const dispatch = useDispatch();
    const search = useLocation().search;

    // 一覧検索/追加系の共通API呼び出しをMD投入表用APIへ差し替える。
    function createMdListRoutingChangeUrl(baseChangeUrl) {
        const source = Array.isArray(baseChangeUrl) ? [...baseChangeUrl] : [];
        const filtered = source.filter((v) => {
            if (typeof v !== 'string') return true;
            const lower = v.toLowerCase();
            if (lower.indexOf("common/getlistdata=") === 0) return false;
            if (lower.indexOf("list/getlist=") === 0) return false;
            return true;
        });
        filtered.push("common/GetListData=mdtounyu/GetListData");
        filtered.push("list/GetList=mdtounyu/GetList");
        return filtered;
    }

    // Redux上のchangeurl差し替え済み判定用。内容が同一かだけを見る。
    function isSameChangeUrl(left, right) {
        if (!Array.isArray(left) || !Array.isArray(right)) return false;
        if (left.length !== right.length) return false;
        for (let i = 0; i < left.length; i++) {
            if (left[i] !== right[i]) return false;
        }
        return true;
    }

    useEffect(() => {
        const current = Array.isArray(changeurl) ? changeurl : [];
        if (!listRoutingInitializedRef.current) {
            listRoutingChangeUrlBackupRef.current = [...current];
            listRoutingInitializedRef.current = true;
        }
        const routed = createMdListRoutingChangeUrl(current);
        if (!isSameChangeUrl(current, routed)) {
            dispatch(setchangeurl(routed));
        }
    }, [changeurl, dispatch]);

    useEffect(() => {
        return () => {
            if (listRoutingInitializedRef.current) {
                dispatch(setchangeurl(listRoutingChangeUrlBackupRef.current));
                listRoutingInitializedRef.current = false;
            }
        };
    }, [dispatch]);

    const gridapiRefs = useRef([]);
    const gridcolapiRefs = useRef([]);
    const griddataRefs = useRef([]);
    const gridcolRefs = useRef([]);

    // パネルIDと種別を結合し、通常パネル/独自セクションの並び順管理キーにする。
    function panelKey(id, type) {
        return id + ":" + (isEmpty(type) ? "" : type);
    }
    // パネル定義から並び順管理キーを取り出す。
    function panelKeyFromItem(item) {
        if (isEmpty(item)) return "";
        return panelKey(item.id, item.type);
    }
    // MD投入表が設定パネルとは別に差し込む独自セクションかを判定する。
    function isCustomSectionKey(key) {
        return CUSTOM_SECTION_KEYS.indexOf(key) !== -1;
    }
    // 通常パネルと独自セクションを含む初期並び順キーを作成する。
    function buildSectionOrderSeed(panels) {
        const keys = [];
        panels.forEach(function (p) {
            keys.push(panelKeyFromItem(p));
        });
        CUSTOM_SECTION_KEYS.forEach(function (ck) {
            keys.push(ck);
        });
        return keys;
    }
    // 現在のパネル定義に合わせて並び順を補正する。
    function syncSectionOrderWithPanels(baseOrder, panels) {
        const panelKeys = panels.map(panelKeyFromItem);
        const validSet = new Set(panelKeys.concat(CUSTOM_SECTION_KEYS));
        const next = [];
        baseOrder.forEach(function (key) {
            if (validSet.has(key) && next.indexOf(key) === -1) next.push(key);
        });
        panelKeys.forEach(function (key) {
            if (next.indexOf(key) === -1) next.push(key);
        });
        CUSTOM_SECTION_KEYS.forEach(function (key) {
            if (next.indexOf(key) === -1) next.push(key);
        });
        return next;
    }
    // セクション順が変わっていない場合は再描画を避ける。
    function sectionOrderEquals(a, b) {
        if (!Array.isArray(a) || !Array.isArray(b)) return false;
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    // 保存済み順序に従ってパネル配列を並べ替える。
    function reorderPanelsBySectionOrder(items, orderKeys) {
        const pos = {};
        orderKeys.forEach(function (key, idx) { pos[key] = idx; });
        return DeepCopy(items).sort(function (a, b) {
            const pa = pos[panelKeyFromItem(a)];
            const pb = pos[panelKeyFromItem(b)];
            const va = pa === undefined ? 9999 : pa;
            const vb = pb === undefined ? 9999 : pb;
            return va - vb;
        });
    }

    //データ
    const entrydataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル  

    // パネル単位でAG Gridデータを保持する。
    function SetGridData(panel, data) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        griddataRefs.current[gidx].current = data;
    }
    // パネル単位で現在のAG Gridデータを取得する。
    function GridData(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return griddataRefs.current[gidx].current;
    }
    // パネル単位でAG Grid列定義を保持する。
    function SetGridColDef(panel, coldef) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolRefs.current[gidx].current = coldef;
    }
    // パネル単位でAG Grid APIを保持する。
    function SetGridApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridapiRefs.current[gidx].current = api;
    }
    // パネル単位で保持したAG Grid APIを取得する。
    function GridApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridapiRefs.current[gidx].current;
    }
    // パネル単位でAG Grid Column APIを保持する。
    function SetGridColApi(panel, api) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return;
        gridcolapiRefs.current[gidx].current = api;
    }
   // パネル単位で保持したAG Grid Column APIを取得する。
   function GridColApi(panel) {
        let gidx = fnc.current.gridindex(panel);
        if (gidx === -1) return null;
        return gridcolapiRefs.current[gidx].current;
    }

    // 素材明細GRIDは横スクロールを出さず、外枠内に全列を収める。
    // メニュー開閉時の再レイアウトを避けるため、同じ列/行/幅ならsignatureでスキップする。
    function applyMaterialGridContentWidth(api, grid, force = false) {
        if (isMaterialGridLayoutFixDisabled()) return;
        if (isEmpty(api) || isEmpty(grid) || isEmpty(fnc.current)) return;
        if (typeof document === "undefined") return;
        if (isMdMainMenuOpen()) return;

        try {
            const gidx = fnc.current.gridindex(grid);
            const columnDefs = gidx === -1 || isEmpty(gridcolRefs.current[gidx])
                ? null
                : gridcolRefs.current[gidx].current;

            const gridId = fnc.current.GridID(grid);
            const gridElement = document.getElementById(gridId);
            // GRIDのDOMがまだ無い場合は、AG Grid側の次の描画イベントで再実行される。
            if (isEmpty(gridElement)) return;
            const wrapper = gridElement.closest(`.${MATERIAL_GRID_CLASS}`);
            const stateKey = panelKey(grid.id, grid.type);
            const layoutSignature = materialGridLayoutSignature(api, gridElement, columnDefs);
            if (!force && layoutSignature !== '' && materialGridLayoutStateRef.current[stateKey] === layoutSignature) return;
            materialGridLayoutStateRef.current[stateKey] = layoutSignature;

            autoSizeMaterialGridColumns(api, columnDefs);

            // 以前のpx指定を残すと右端列が隠れるため、素材明細だけ親幅いっぱいに戻す。
            [wrapper, gridElement].forEach((element) => {
                if (isEmpty(element)) return;
                element.style.width = '100%';
                element.style.minWidth = '0';
                element.style.maxWidth = '100%';
                element.style.overflowX = 'hidden';
            });

            try {
                if (!isEmpty(api.setGridOption)) {
                    api.setGridOption('suppressHorizontalScroll', true);
                    api.setGridOption('suppressColumnVirtualisation', false);
                }
            } catch {
            }
            if (!isEmpty(api.sizeColumnsToFit)) api.sizeColumnsToFit();
            if (!isEmpty(api.refreshHeader)) api.refreshHeader();
        } catch {
        }
    }

    // 同一フレーム内の補正要求を1回にまとめる。メニュー表示中は予約自体を行わない。
    function scheduleMaterialGridContentWidth(api, grid, force = false) {
        if (isMaterialGridLayoutFixDisabled()) return;
        if (isEmpty(api) || isEmpty(grid) || isMdMainMenuOpen()) return;
        if (typeof window === "undefined" || typeof window.requestAnimationFrame !== "function") {
            applyMaterialGridContentWidth(api, grid, force);
            return;
        }
        const stateKey = panelKey(grid.id, grid.type);
        if (materialGridLayoutRafRef.current[stateKey]) {
            if (!force) return;
            window.cancelAnimationFrame(materialGridLayoutRafRef.current[stateKey]);
        }
        materialGridLayoutRafRef.current[stateKey] = window.requestAnimationFrame(() => {
            materialGridLayoutRafRef.current[stateKey] = 0;
            applyMaterialGridContentWidth(api, grid, force);
        });
    }

    // 共通GRIDの再描画で標準行番号設定に戻っても、素材明細だけA/B/C/D表示を維持する。
    useEffect(() => {
        if (isMaterialGridLayoutFixDisabled()) return;
        if (isMdMainMenuOpen()) return;
        if (!Array.isArray(gridlist) || gridlist.length === 0) return;
        if (isEmpty(fnc.current)) return;
        if (typeof window === "undefined" || typeof window.requestAnimationFrame !== "function") return;

        const raf = window.requestAnimationFrame(() => {
            if (isMdMainMenuOpen()) return;
            gridlist.forEach((grid) => {
                if (!isMaterialDetailGridPanel(grid)) return;
                const api = GridApi(grid);
                if (isEmpty(api)) return;
                applyMaterialGridRowNumbers(api);
                scheduleMaterialGridContentWidth(api, grid);
            });
        });

        return () => {
            window.cancelAnimationFrame(raf);
        };
    }, [gridlist, panel, columns]);

    const actionurl = {
        "getlist": "mdtounyu/GetList",
        "insert": "mdtounyu/Insert",
         "update": "mdtounyu/Update",
         "delete": "mdtounyu/Delete",
         "saveas": "mdtounyu/SaveAs",
         "storageadd": "mdtounyu/AddStorage",
         "storagerowdel": "mdtounyu/StorageRowdel",
         "upload": "mdtounyu/Upload"
    }

    const navmenu = [
        { status: "ENTRY FORM", menuid: "print_md_tounyu", icon: "print", label: "MD投入表発行", title: "MD投入表を出力します" },
        { status: "ENTRY FORM", menuid: "print_md_map", icon: "print", label: "MDマップ発行", title: "MDマップを出力します" },
        { status: "ENTRY FORM", menuid: "print_tenjikai_md_map", icon: "print", label: "展示会MDマップ発行", title: "展示会MDマップを出力します" },
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "upload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
    ]

    function isBasicInfoPanelType(type) {
        return ["0", BASIC_INFO_TAB_TYPE.INPUT, BASIC_INFO_TAB_TYPE.ORDER, BASIC_INFO_TAB_TYPE.DELIVERY].indexOf(type) !== -1;
    }
    function isBottomSectionPanel(pnl) {
        if (isEmpty(pnl)) return false;
        return pnl.id === G_id.BASE && pnl.type === "0";
    }
    function initialOrderedPanels(items) {
        const normal = [];
        const bottom = [];
        items.forEach(function (item) {
            if (isBottomSectionPanel(item)) item.hide = false;
            if (isBottomSectionPanel(item)) bottom.push(item);
            else normal.push(item);
        });
        return normal.concat(bottom);
    }

    function rerender() {
        setUpdata(update ? false : true);
    }
    // 引数未指定時は最新の投入ブロックを状態から解決する。
    function selectedInputBlocks(blocks) {
        if (Array.isArray(blocks)) return blocks;
        if (Array.isArray(inputBlocksStateRef.current)) return inputBlocksStateRef.current;
        return resolveInputBlocks(tabBaseInfo);
    }
    function currentTabBaseInfo() {
        const source = tabBaseInfo || emptyTabBaseInfo();
        if (!Array.isArray(inputBlocksStateRef.current)) return source;
        return {
            ...source,
            input: { ...(source.input || {}), _INPUT_BLOCKS: inputBlocksStateRef.current }
        };
    }
    // 指定フラグがONの投入ブロックだけ抽出する。
    function targetBlocksByFlag(blocks, flagName) {
        return selectedInputBlocks(blocks).filter((row) => String(row ? row[flagName] : '') === '1');
    }
    // 発注対象のうち「除外区分=2」を除いた有効明細を返す。
    function effectiveOrderTargets(blocks) {
        return targetBlocksByFlag(blocks, "_ORDER_TARGET").filter((row) => String(row ? row.SSD_HachuTaisyoFlg : '') !== '2');
    }
    function targetLabel(block) {
        if (isEmpty(block)) return '';
        return block.TNYM_Hinban || block.TNYM_OppiCd || block.SSD_No || '';
    }
    // 製商品発注の承認簡略化判定で使用する「企画元」(D_TNY.TNY_TonyuKikaMoto) を取得する。
    function resolveProductOrderKikakuMoto() {
        const source = entrydataRef.current || {};
        for (let i = 0; i < MD_KIKAKUMOTO_FIELD_KEYS.length; i++) {
            const key = MD_KIKAKUMOTO_FIELD_KEYS[i];
            if (!(key in source)) continue;
            const value = String(source[key] || '').trim();
            if (value !== '') return value;
        }
        return '';
    }
    // DB物理名/モデル名の大文字小文字差を吸収して列ID比較する。
    function normalizeMdColumnId(id) {
        return String(id || '').toUpperCase();
    }
    // 対象列IDの候補リストに一致するかを判定する。
    function isMdColumnId(id, keys) {
        const target = normalizeMdColumnId(id);
        return keys.some((key) => normalizeMdColumnId(key) === target);
    }
    // null/undefinedを空文字へ寄せ、入力有無判定を安定させる。
    function mdValueText(value) {
        if (value === null || value === undefined) return '';
        return String(value).trim();
    }
    // 入力中の値を優先しつつ、現在のフォームデータから対象列の値を取得する。
    function mdEntryValue(keys, overrideId, overrideValue) {
        // onChange直後はentrydataRefの反映前でも判定できるよう、引数の値を優先する。
        if (isMdColumnId(overrideId, keys)) return overrideValue;
        const source = entrydataRef.current || {};
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (key in source) return source[key];
        }
        return '';
    }
    // 発注元を入力可能にしてよいかを決めるため、企画元の入力有無を判定する。
    function hasMdKikakuMotoValue(overrideId, overrideValue) {
        return mdValueText(mdEntryValue(MD_KIKAKUMOTO_FIELD_KEYS, overrideId, overrideValue)) !== '';
    }
    // レイアウト種別も含めて、同じ列IDでも別フィールドとしてロック状態を保持する。
    function mdFieldLockKey(field) {
        if (isEmpty(field)) return '';
        return String(field.type || '') + ':' + String(field.columnid || '');
    }
    // 実データ/列定義/設定フィールドから、現在画面で使われている実列IDを収集する。
    function actualEntryDataKeys(keys) {
        const result = [];
        const add = function (id) {
            // 対象外の列は発注元クリア対象に含めない。
            if (isEmpty(id)) return;
            if (!isMdColumnId(id, keys)) return;
            if (result.some((key) => normalizeMdColumnId(key) === normalizeMdColumnId(id))) return;
            result.push(id);
        };
        const source = entrydataRef.current || {};
        Object.keys(source).forEach(add);
        if (Array.isArray(columninfo)) columninfo.forEach((col) => add(col ? col.columnid : ''));
        if (Array.isArray(textfields)) textfields.forEach((col) => add(col ? col.columnid : ''));
        keys.forEach(add);
        return result;
    }
    // 企画元を空にした場合は、発注元も空にして矛盾した組み合わせを残さない。
    function clearHachuMotoEntryValue() {
        const source = entrydataRef.current || {};
        let next = source;
        let changed = false;
        actualEntryDataKeys(MD_HACHUMOTO_FIELD_KEYS).forEach((key) => {
            // 画面データに存在しない候補列はスキップする。
            if (!(key in source)) return;
            // 既に空ならデータ参照を差し替えず、不要な再描画を避ける。
            if (mdValueText(source[key]) === '') return;
            if (!changed) next = { ...source };
            next[key] = '';
            changed = true;
        });
        if (changed) entrydataRef.current = next;
    }
    // 発注元フィールドへMD独自のロック状態を反映する。
    function applyHachuMotoLock(fields, shouldLock) {
        if (!Array.isArray(fields)) return fields;
        let changed = false;
        const next = fields.map((field) => {
            if (isEmpty(field) || !isMdColumnId(field.columnid, MD_HACHUMOTO_FIELD_KEYS)) return field;
            const key = mdFieldLockKey(field);
            // 初回はs_layout等の設定由来のロック状態を保存しておく。
            if (!(key in hachuMotoOriginalLockedRef.current)) {
                hachuMotoOriginalLockedRef.current[key] = Boolean(field.locked);
            } else if (!hachuMotoDynamicLockedRef.current[key]) {
                // MD側で追加ロックしていない状態なら、設定変更後のロック状態を取り直す。
                hachuMotoOriginalLockedRef.current[key] = Boolean(field.locked);
            }
            // 設定で元々ロックされている列は、企画元が入っても解除しない。
            const nextLocked = Boolean(hachuMotoOriginalLockedRef.current[key]) || shouldLock;
            hachuMotoDynamicLockedRef.current[key] = shouldLock && !Boolean(hachuMotoOriginalLockedRef.current[key]);
            if (Boolean(field.locked) === nextLocked) return field;
            changed = true;
            return { ...field, locked: nextLocked };
        });
        return changed ? next : fields;
    }
    // 企画元の有無に応じて、発注元の入力可否を同期する。
    function syncHachuMotoLock(options) {
        const opt = options || {};
        const shouldLock = !hasMdKikakuMotoValue(opt.overrideId, opt.overrideValue);
        // ユーザー操作で企画元を消した時だけ、発注元の値も消す。
        if (shouldLock && opt.clearValue) clearHachuMotoEntryValue();
        settextfields((prev) => applyHachuMotoLock(prev, shouldLock));
    }
    useEffect(() => {
        syncHachuMotoLock();
    }, [textfields]);
    // 投入表番号未選択時の共通ガード。
    function ensureEntryCode() {
        if (!isEmpty(edittingcode)) return true;
        return false;
    }
    function createPlaceholderTabs(count) {
        const tabs = [];
        if (count <= 0) return tabs;
        const firstTab = window.open("", "_blank");
        preparePlaceholderTab(firstTab);
        tabs.push(firstTab);
        for (let i = 1; i < count; i++) {
            let tab = null;
            try {
                // 環境によっては親タブから複数回 open するより、最初に開いたタブを起点にした方が
                // ユーザー操作由来として扱われやすい。
                tab = firstTab && !firstTab.closed ? firstTab.open("", "_blank") : window.open("", "_blank");
            } catch (error) {
                tab = null;
            }
            preparePlaceholderTab(tab);
            tabs.push(tab);
        }
        return tabs;
    }
    function preparePlaceholderTab(tab) {
        if (tab && !tab.closed) {
            try {
                tab.document.title = "起動中";
            } catch (error) {
            }
        }
    }

    // 別画面遷移        26/7/7 Honma
    function openPlaceholderTab(formkind, targets) {
        switch (formkind) {
            case "ProductOrder":    //製商品発注入力
                const placeholderTabs = createPlaceholderTabs(targets.length);
                ProductOrderCallForm(targets.map(x => x.SSD_No), placeholderTabs);
                break;
            case "MaterialOrder":   //原材料発注入力
                var state = { status: "ENTRY", code: "", accepttype: formid, acceptno: edittingcode };
                fnc.current.callform(state, "RawM?type=D_KHD");
                break;
            case "subMaterial":     //副資材一括
                openAuxMatBulkTab(targets);
        }
    }
    //製商品発注入力
    function ProductOrderCallForm(code, placeholderTabs = []) {
        //製商品発注情報の収集
        fnc.current.postaxios("kakousiji/GetCallFormStatus", { action:'seihin_bulk_order', keys: code },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);
                    const requests = buildCallformRequests( code, data.rowdata);
                    if (requests.length === 0) {
                        closePlaceholderTabs(placeholderTabs);
                        setPendingOrderLaunches([]);
                        return;
                    }
                    const targetTab = placeholderTabs.length !== 0 ? placeholderTabs[0] : null;
                    const firstOpenedTab = fnc.current.callform(requests[0].state, requests[0].callid, targetTab);
                    closePlaceholderTabs(placeholderTabs, 1);
                    if (firstOpenedTab === null) {
                        setPendingOrderLaunches(requests);
                        fnc.current.warnmsg("ブラウザ制限のため自動で複数タブを開けません。起動一覧から 1 件ずつ開いてください。");
                        return;
                    }
                    const remains = requests.slice(1);
                    setPendingOrderLaunches(remains);
                },
                onError: function () {
                    setPendingOrderLaunches([]);
                    closePlaceholderTabs(placeholderTabs);
                    fnc.current.wait(false);
                }
            }
        );
    }
    function pendingOrderLaunchLabel(item) {
        if (isEmpty(item)) return "";
        return "起動対象 " + (item.index + 1);
    }
    function openPendingOrderLaunch(item) {
        if (isEmpty(item)) return false;
        const openedTab = fnc.current.callform(item.state, item.callid);
        if (openedTab === null) {
            fnc.current.warnmsg("タブを開けませんでした。ブラウザのポップアップ設定を確認してください。");
            return false;
        }
        setPendingOrderLaunches((prev) => prev.filter((entry) => entry.index !== item.index));
        return true;
    }
   function buildCallformRequests(code, rowdata) {
        const callid = "ShnOrder";
        return (Array.isArray(rowdata) ? rowdata : []).map((detail, index) => ({
            index: index,
            callid: callid,
            state: { status: "ENTRY", code: "", accepttype: formid, acceptno: code, detail: detail }
        }));
    }
    function closePlaceholderTabs(tabs, startIndex = 0) {
        if (!Array.isArray(tabs)) return;
        for (let i = startIndex; i < tabs.length; i++) {
            const tab = tabs[i];
            if (tab && !tab.closed) {
                try {
                    tab.close();
                } catch (error) {
                }
            }
        }
    }

    // 副資材一括登録画面を別タブで開く。
    function openAuxMatBulkTab(targets) {
        const ssdNos = targets.map((row) => String(row.SSD_No || '').trim()).filter((v) => v !== '');
        const oppiCds = targets.map((row) => String(row.TNYM_OppiCd || row.PDT_OppiCd || '').trim()).filter((v) => v !== '');
        const firstSsdNo = ssdNos.length === 0 ? '' : ssdNos[0];
        const url = '/AuxMatBulk'
            + '?controller=AuxMatBulk'
            + '&code=' + encodeURIComponent(firstSsdNo)
            + '&tnyNo=' + encodeURIComponent(edittingcode)
            + '&ssdNos=' + encodeURIComponent(ssdNos.join(','))
            + '&oppiCds=' + encodeURIComponent(oppiCds.join(','));
        return window.open(url, '_blank');
    }
    function hasInputDetailBlock(row) {
        if (isEmpty(row)) return false;
        return !isEmpty(row.TNYM_OppiCd) || !isEmpty(row.TNYM_Hinban) || !isEmpty(row.SSD_No);
    }
    function saveCheckTargetBlocks() {
        return selectedInputBlocks().filter((row) => hasInputDetailBlock(row));
    }
    function isBlankRequiredInputValue(value) {
        return value === undefined || value === null || String(value).trim() === '';
    }
    function validateRequiredInputFields(blocks) {
        const targets = Array.isArray(blocks) ? blocks : [];
        const errors = MD_INPUT_REQUIRED_FIELD_DEFS
            .map((fieldDef) => {
                const missingTargets = targets
                    .map((row, index) => isBlankRequiredInputValue(row ? row[fieldDef.key] : '')
                        ? (targetLabel(row) || `${index + 1}件目`)
                        : '')
                    .filter((label) => label !== '');
                return {
                    label: fieldDef.label,
                    targets: missingTargets
                };
            })
            .filter((error) => error.targets.length !== 0);

        if (errors.length === 0) return true;

        setbasicInfoTab('input');
        fnc.current.warnmsg([
            '投入数タブの必須項目が入力されていません。',
            ...errors.map((error) => `${error.label}（対象：${error.targets.join('、')}）`)
        ]);
        return false;
    }
    // 登録前の確認分岐を実行する。登録不可チェックは拡張フック側で行う。
    function canContinueSave(finallycallback, nocheck) {
        const saveBlocks = saveCheckTargetBlocks();
        if (!validateRequiredInputFields(saveBlocks)) return false;
        const activeBlocks = saveBlocks.filter((row) => String(row.TNYM_StopFlg || '') !== '1');

        // 確認ダイアログ未スキップ時のみ、発注不可仕入先の最終確認を出す
        if (!nocheck) {
            const supplierNg = activeBlocks.some((row) => String(row.TOR_HachuNGFlg || '') === '1');
            if (supplierNg) {
                // OK押下時は nocheck=true で再入して保存を続行
                fnc.current.confmsg("発注不可の仕入先です。登録しますか？", () => Save(finallycallback, true));
                return false;
            }
        }

        return true;
    }
    // チャット画面遷移の入口アクション。
    function chatButtonClick() {
        if (!ensureEntryCode()) return;
        openPlaceholderTab();
    }
    // 複数候補キーから最初に見つかった文字値を取得する。
    function firstReportValue(source, keys) {
        if (isEmpty(source) || !Array.isArray(keys)) return '';
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (!(key in source)) continue;
            const value = String(source[key] || '').trim();
            if (value === '') continue;
            return value;
        }
        return '';
    }
    // 現在の投入表番号を帳票出力用に解決する。
    function currentMdReportCode() {
        return firstReportValue(entrydataRef.current || {}, ["TNY_NO"]) || String(edittingcode || '').trim();
    }
    // 基本情報の投入数ブロックから最初の有効行を取得する。
    function firstMdReportInputBlock() {
        const blocks = selectedInputBlocks();
        if (!Array.isArray(blocks)) return {};
        return blocks.find((row) => !isEmpty(row) && (
            !isEmpty(row.TNYM_Hinban) ||
            !isEmpty(row.TNYM_OppiCd) ||
            !isEmpty(row.PDT_BrdCode) ||
            !isEmpty(row.PDT_BRDCODE)
        )) || {};
    }
    // 展示会MDマップは品番必須のため、投入数ブロック優先で品番を拾う。
    function firstMdReportHinban() {
        const block = firstMdReportInputBlock();
        return firstReportValue(block, [
            "TNYM_Hinban",
            "TNYM_HINBAN",
            "PDT_SyohinCD",
            "PDT_SYOHINCD",
            "SJCM_HINBAN"
        ]);
    }
    // RawM.jsと同じく、帳票生成APIの結果をExcelDownloadへ渡す。
    function downloadGeneratedReport(endpoint, payload) {
        fnc.current.postaxios(endpoint, payload, {
            onSuccess: function (data) {
                let params = {
                    "excelfile": data.returnData["filename"],
                    "dnfile": data.returnData["dnfile"]
                };
                fnc.current.filedownload("excel/ExcelDownload", params);
                fnc.current.wait(false);
            },
            errmsg: "処理に失敗しました"
        });
    }
    // ENTRY FORMメニューの帳票発行コマンドを実行する。
    function printMdReport(action) {
        if (!ensureEntryCode()) return;
        const code = currentMdReportCode();
        if (isEmpty(code)) {
            fnc.current.warnmsg("投入表番号を取得できません。");
            return;
        }

        if (action === "print_md_tounyu") {
            downloadGeneratedReport("MDTounyuReport/Generate", {
                controller: controller,
                id: action,
                keys: [code],
                tnyNo: code
            });
            return;
        }

        if (action === "print_md_map") {
            downloadGeneratedReport("TenkaiBoardMdMapReport/Generate", {
                param: code
            });
            return;
        }

        if (action === "print_tenjikai_md_map") {
            const hinban = firstMdReportHinban();
            if (isEmpty(hinban)) {
                fnc.current.warnmsg("展示会MDマップの出力条件に使用する品番を取得できません。");
                return;
            }
            downloadGeneratedReport("TenjikaiMdMapReport/Generate", {
                controller: controller,
                id: action,
                keys: [code],
                param: hinban,
                data: {
                    hinban: hinban,
                    tnyNo: code
                }
            });
        }
    }
    function extractSearchListRowData(item) {
        if (isEmpty(item)) return null;
        if (item.data) return item.data;
        return item;
    }
    function inputBlockIdentity(block) {
        if (isEmpty(block)) return '';
        const ssdNo = String(block.SSD_No || block.SSD_NO || '').trim();
        const oppiCd = String(block.TNYM_OppiCd || block.TNYM_OPPICD || block.PDT_OppiCd || '').trim();
        if (ssdNo !== '') return ssdNo + '\u001f' + oppiCd;
        return oppiCd === '' ? '' : ('OPPI\u001f' + oppiCd);
    }
    // DB登録済みの品番・加工指示を、MD投入表未登録の仮カードとして画面状態へ追加する。
    function appendTemporaryInputBlocks(rows, source) {
        const temporarySource = source === 'new' ? 'new' : 'registered';
        const received = (Array.isArray(rows) ? rows : [])
            .filter((row) => !isEmpty(row))
            .map((row) => ({
                ...row,
                _MD_TEMPORARY: '1',
                _MD_TEMPORARY_SOURCE: temporarySource,
                _ORDER_TARGET: '',
                _SUB_MATERIAL_TARGET: ''
            }));
        if (received.length === 0) return;

        const current = selectedInputBlocks();
        const existing = new Set(current.map(inputBlockIdentity).filter((key) => key !== ''));
        const added = [];
        received.forEach((row) => {
            const key = inputBlockIdentity(row);
            if (key !== '' && existing.has(key)) return;
            if (key !== '') existing.add(key);
            added.push(row);
        });
        if (added.length === 0) return;

        updateInputBlocksState(current.concat(added), true);
        setbasicInfoTab('input');
        if (fnc.current && fnc.current.modify) fnc.current.modify();
    }
    function loadTemporaryInputBlocks(codes, source) {
        const targets = (Array.isArray(codes) ? codes : [])
            .map((code) => String(code || '').trim())
            .filter((code) => code !== '');
        if (targets.length === 0) return;
        const temporarySource = source === 'new' ? 'new' : 'registered';

        fnc.current.postaxios("mdtounyu/GetTemporaryInputBlocks", {
            codes: targets,
            source: temporarySource
        }, {
            onSuccess: function (data) {
                if (fnc.current && fnc.current.wait) fnc.current.wait(false);
                appendTemporaryInputBlocks(data && Array.isArray(data.rowdata) ? data.rowdata : [], temporarySource);
            },
            onError: function (data) {
                if (fnc.current && fnc.current.wait) fnc.current.wait(false);
                if (!isEmpty(data) && !isEmpty(data.errDescription)) fnc.current.warnmsg(data.errDescription);
            }
        });
    }
    // 登録済品番追加の共通検索リストを起動し、選択結果を反映する。
    function addExistsClick(blocks) {
        // 共通検索リストAPIが利用できる状態かを確認
        if (!fnc.current || !fnc.current.searchlistopen) {
            return;
        }
            fnc.current.searchlistopen({
                label: "登録済品番追加",
                multiple: true,
                rowmode: false,
                data: {
                    dataid: "FD_SSD:MDADD",
                    columnid: "__mdtounyu_add_exists__",
                    columnnm: "登録済品番追加",
                    datatype: CELLTYPE.TEXT,
                },
                rowdata: entrydataRef.current || {},
                doApply: function (e) {
                    // 検索リスト選択結果を row データ配列へ正規化
                    const items = Array.isArray(e && e.items) ? e.items : [];
                    const rows = items
                        .map((item) => extractSearchListRowData(item))
                        .filter((row) => !isEmpty(row));
                    // 連携キーは "SSD_NO:OPPI_CD" 形式の code を使用
                    const selectedCodes = rows
                        .map((row) => {
                            const directCode = String(row.code || '').trim();
                            if (directCode !== '') return directCode;
                            const ssdNo = String(row.SSD_NO || '').trim();
                            const oppiCd = String(row.SSD_OPPICD || '').trim();
                            return ssdNo === '' ? '' : (ssdNo + ':' + oppiCd);
                        })
                        .filter((code) => code !== '');

                    // 未選択で適用された場合はAPIを呼ばずに終了
                    if (selectedCodes.length === 0) {
                        if (fnc.current && fnc.current.searchlistclose) fnc.current.searchlistclose();
                        return;
                    }

                    // 選択時点ではDBを更新せず、取得した内容から仮カードだけを追加する。
                    if (fnc.current && fnc.current.searchlistclose) fnc.current.searchlistclose();
                    loadTemporaryInputBlocks(selectedCodes, 'registered');
                }
            });


    }
    // 新規品番追加用のモーダルを開く。
    function buildHinbanDialogInitialValues() {
        const header = entrydataRef.current || {};

        return {
            jutakuHinFlg: header.TNY_JUTAKUHINFLG || ''
        };
    }
    function addNewClick() {
        setHinbanDialogInitialValues(buildHinbanDialogInitialValues());
        setHinbanDialogOpen(true);
    }
    function closeHinbanDialog() {
        setHinbanDialogOpen(false);
    }
    function handleHinbanRegisterSuccess(data) {
        setHinbanDialogOpen(false);
        const returnData = data && data.returnData ? data.returnData : {};
        const ssdNo = String(returnData.SSD_NO || (data ? data.request : '') || '').trim();
        const oppiCd = String(returnData.PDT_OPPICD || (data ? data.results : '') || '').trim();
        if (ssdNo === '') return;
        const temporaryLookupCode = oppiCd === '' ? ssdNo : `${ssdNo}:${oppiCd}`;
        loadTemporaryInputBlocks([temporaryLookupCode], 'new');
    }
    // 製商品発注の事前チェックを行い、対象画面へ遷移する。
    function productOrderClick(blocks) {
        // 投入表番号の存在確認
        if (!ensureEntryCode()) return;
        // チェックボックスで「製商品発注」対象にした行を確認
        const selected = targetBlocksByFlag(blocks, "_ORDER_TARGET");
        if (selected.length === 0) {
            fnc.current.warnmsg("製商品発注対象を選択してください。");
            return;
        }
        // 発注除外フラグ(=2)を除外した実対象
        const targets = effectiveOrderTargets(blocks);
        if (targets.length === 0) {
            fnc.current.warnmsg("製商品発注対象を選択してください。");
            return;
        }

        function continueProductOrderCheck() {
            const stopRows = targets.filter((row) => {
                const pdtStop = String(row.PDT_StopFlg || '');
                return pdtStop === '1';
            });
            if (stopRows.length !== 0) {
                fnc.current.warnmsg("品番中止の明細が存在するため、発注できません。");
                return;
            }
            // サイズ・カラー未展開は発注不可
            const noColorSizeRows = targets.filter((row) => !hasColorSizeData(row));
            if (noColorSizeRows.length !== 0) {
                fnc.current.warnmsg("サイズ・カラー未設定の品番があります。サイズ・カラーを展開してください。");
                return;
            }
            // 納期未設定は発注不可
            const noButuryuRows = targets.filter((row) => isEmpty(row.TNYM_ButuryuNouki));
            if (noButuryuRows.length !== 0) {
                fnc.current.warnmsg("物流納期未入力の明細が存在するため、発注できません。");
                return;
            }
            // 上代0/未設定は発注不可
            const noJyodaiRows = targets.filter((row) => Number.isNaN(toNum(row.PDT_Price)) || toNum(row.PDT_Price) === 0);
            if (noJyodaiRows.length !== 0) {
                fnc.current.warnmsg("上代が入力されていない品番があります。");
                return;
            }
            // すでに発注数量または発注伝票がある場合は二重発注防止
            const orderedRows = targets.filter((row) => {
                const orderedQty = toNum(row.SSDM_SeiHachusu);
                const hasOrderQty = !Number.isNaN(orderedQty) && orderedQty > 0;
                const hasOrderNo = !isEmpty(row.SSD_SeihinHachuDenno);
                return hasOrderQty || hasOrderNo;
            });
            if (orderedRows.length !== 0) {
                fnc.current.warnmsg("このデータは既に発注されています。");
                return;
            }
            const supplierNgRows = targets.filter((row) => String(row.TOR_HachuNGFlg || '') === '1');
            if (supplierNgRows.length !== 0) {
                fnc.current.warnmsg("発注不可の仕入先です。");
                return;
            }
            // MD発注数が0の行を除外
            const noQtyRows = targets.filter((row) => getBlockInputQtyTotal(row) <= 0);
            if (noQtyRows.length !== 0) {
                const labels = noQtyRows.map(targetLabel).filter((v) => !isEmpty(v));
                const suffix = labels.length === 0 ? "" : (labels.join("、"));
                fnc.current.warnmsg("MD発注数は必須です。MD発注数が０の品番：" + suffix);
                return;
            }
            // 発注単価0/未設定は発注不可
            const noTankaRows = targets.filter((row) => Number.isNaN(toNum(row.TNYM_SeiHatchuTanka)) || toNum(row.TNYM_SeiHatchuTanka) === 0);
            if (noTankaRows.length !== 0) {
                const labels = noTankaRows.map(targetLabel).filter((v) => !isEmpty(v));
                const suffix = labels.length === 0 ? "" : (labels.join("、"));
                fnc.current.warnmsg("発注単価は必須です。発注単価が０の品番：" + suffix);
                return;
            }

            openPlaceholderTab("ProductOrder", targets);    //26/7/7 Honma
        }

        const approvalTargets = targets.map((row) => ({
            oppiCd: row.TNYM_OppiCd || '',
            hinban: row.TNYM_Hinban || '',
            ssdNo: row.SSD_No || '',
            synFlg: String(row.PDT_SynFlg1 || '')
        }));
        fnc.current.postaxios("mdtounyu/CheckProductOrderApproval", {
            code: edittingcode,
            kikakuMoto: resolveProductOrderKikakuMoto(),
            targets: approvalTargets
        }, {
            onSuccess: function () {
                fnc.current.wait(false);
                continueProductOrderCheck();
            },
            onError: function (data) {
                fnc.current.wait(false);
                if (!isEmpty(data) && !isEmpty(data.errDescription)) fnc.current.warnmsg(data.errDescription);
            }
        });
    }
    // 副資材登録対象チェック後に画面遷移する。
    function subMaterialClick(blocks) {
        if (!ensureEntryCode()) return;
        const targets = targetBlocksByFlag(blocks, "_SUB_MATERIAL_TARGET");
        if (targets.length === 0) {
            fnc.current.warnmsg("副資材登録対象を選択してください。");
            return;
        }
        const stopRows = targets.filter((row) => {
            const tnymStop = String(row.TNYM_StopFlg || '');
            const pdtStop = String(row.PDT_StopFlg || '');
            return ["1", "2"].indexOf(tnymStop) !== -1 || pdtStop === '2';
        });
        if (stopRows.length !== 0) {
            fnc.current.warnmsg("中止の品番が存在するため、選択できません。");
            return;
        }
        const noColorRows = targets.filter((row) => {
            const qtyRows = parseBlockQtyRows(row);
            return qtyRows.length === 0 || !qtyRows.some((r) => !isEmpty(r && r.color));
        });
        if (noColorRows.length !== 0) {
            fnc.current.warnmsg("カラー未設定の品番があります。カラーを登録してください。");
            return;
        }
        openPlaceholderTab("subMaterial", targets); //26/7/7 Honma
    }
    // 品番ブロックを画面状態から除外する。DBの紐づけ解除はヘッダ登録時に行う。
    function unlinkBlockClick(blockData) {
        const targetKey = inputBlockIdentity(blockData);
        const current = selectedInputBlocks();
        const next = current.filter((row) => {
            if (row === blockData) return false;
            const key = inputBlockIdentity(row);
            return targetKey === '' || key !== targetKey;
        });
        if (next.length === current.length) return;
        updateInputBlocksState(next, true);
        if (fnc.current && fnc.current.modify) fnc.current.modify();
    }
    // 中止フラグはカード内の画面状態だけを変更し、ヘッダ登録時に一括保存する。
    function stopFlagToggleClick(blockData, checked) {
        void blockData;
        void checked;
        if (fnc.current && fnc.current.modify) fnc.current.modify();
    }
    // 投入数タブ内の画面状態を保持する。通常入力は再描画を避けるためrefへ保持する。
    function updateInputBlocksState(nextBlocks, updateView = false) {
        const blocks = Array.isArray(nextBlocks) ? nextBlocks : [];
        inputBlocksStateRef.current = blocks;
        if (!updateView) return;
        settabBaseInfo((prev) => {
            const source = prev || {};
            return {
                ...source,
                input: { ...(source.input || {}), _INPUT_BLOCKS: blocks }
            };
        });
    }
    // 受注数タブの表示内容を投入数下段へ反映する（画面表示のみ。DB更新はしない）。
    function applyInputQtyClick(cards) {
        if (!ensureEntryCode()) return;

        const orderCards = Array.isArray(cards) ? cards : [];
        if (orderCards.length === 0) {
            return;
        }

        const currentBlocks = selectedInputBlocks();
        if (currentBlocks.length === 0) {
            return;
        }

        const groupsByHinban = {};
        orderCards.forEach((card) => {
            const hinban = String(card && card.hinban ? card.hinban : '').trim();
            if (hinban === '') return;
            if (!groupsByHinban[hinban]) groupsByHinban[hinban] = [];
            const groups = Array.isArray(card && card.groups) ? card.groups : [];
            groups.forEach((group) => groupsByHinban[hinban].push(group));
        });

        let updateCount = 0;
        const nextBlocks = currentBlocks.map((block) => {
            const hinban = String(block && block.TNYM_Hinban ? block.TNYM_Hinban : '').trim();
            const groups = groupsByHinban[hinban];
            if (!Array.isArray(groups) || groups.length === 0) return block;

            const qtyMatrix = buildQtyMatrixFromOrderCard({ groups: groups });
            const nextBlock = { ...block };
            nextBlock._QTY_SIZES = qtyMatrix.sizes;
            nextBlock._QTY_ROWS = qtyMatrix.rows;
            nextBlock._QTY_TOTALS = qtyMatrix.totals;
            nextBlock._QTY_TOTAL_M = qtyMatrix.totalM;
            nextBlock._QTY_TOTAL_L = qtyMatrix.totalL;
            // 見た目反映時も常に受注側の集計値で上書きし、古い値を残さない。
            nextBlock.TNYM_MDHatchusu = qtyMatrix.grandTotal;
            updateCount++;
            return nextBlock;
        });

        if (updateCount === 0) {
            return;
        }

        updateInputBlocksState(nextBlocks, true);

        setbasicInfoTab('input');
        if (fnc.current && fnc.current.modify) fnc.current.modify();
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    //主キー取得
    function primarykey() {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.primarykey)) return "";
        return columninfo.find(e => e.primarykey).columnid;
    }
    //項目名取得
    function nametocolumn(name) {
        if (isEmpty(columninfo)) return "";
        if (!columninfo.some(e => e.columnid.indexOf(name) !== -1)) return "";
        return columninfo.find(e => e.columnid.indexOf(name) !== -1).columnid;
    }

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    const orderedPanels = initialOrderedPanels(data.panels);
                    const storedSectionOrder = Getstorage(corpkey, account, formid + SECTION_ORDER_STORAGE_SUFFIX);
                    const nextSectionOrder = Array.isArray(storedSectionOrder) && storedSectionOrder.length !== 0
                        ? syncSectionOrderWithPanels(storedSectionOrder, orderedPanels)
                        : syncSectionOrderWithPanels(buildSectionOrderSeed(orderedPanels), orderedPanels);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);

                    let idx = 0;
                    let glist = [];
                    data.panels.filter(e => e.grid).forEach(function (panel) {
                        gridapiRefs.current[idx] = createRef();
                        gridcolapiRefs.current[idx] = createRef();
                        griddataRefs.current[idx] = createRef();
                        gridcolRefs.current[idx] = createRef();
                        glist.push({ id: panel.id, type: panel.type, index: idx });
                        idx++;
                    });

                    unstable_batchedUpdates(function () {
                        setpanel(orderedPanels);
                        setsectionOrder(nextSectionOrder);
                        dispatch(reports(data.reports));
                        dispatch(setentrypanel({
                            layouts: data.layouts, prelayout: data.prelayout,
                            initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                            fitColumn: data.fitColumn
                        }));
                        setcolumninfo(data.colinfo);
                        setcolumns(data.columns);
                        settextfieldsall(fields);
                        settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                        setprimarykeys(data.primarykeys);
                        dispatch(setgridlist(glist));
                    });
                    reportsRef.current = data.reports || [];

                    fnc.current.initMaster(data.master);

                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            if (state.code === "") clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
               }
            });
    }, [search]);

    useEffect(() => {
        if (isEmpty(panel)) return;
        setsectionOrder(function (prev) {
            const current = Array.isArray(prev) ? prev : [];
            const next = syncSectionOrderWithPanels(current, panel);
            return sectionOrderEquals(current, next) ? current : next;
        });
    }, [panel]);

    useEffect(() => {
        if (isEmpty(menuCtrls)) return;
        setlayoutlock(menuCtrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuCtrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuCtrls]);

    useEffect(() => {
        if (formstatus === "COPY FORM") {
            columninfo.filter(e => e.copyclear).forEach(function (col) {
                entrydataRef.current[col.columnid] = "";
            });
            rerender();
        }
    }, [formstatus]);

    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform();
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }
    function onFirstDataRendered(param, panel) {
        SetGridApi(panel, param.api);
        SetGridColApi(panel, param.api);

        if (isMaterialDetailGridPanel(panel)) {
            hideMaterialGridSystemColumns(param);
            scheduleMaterialGridContentWidth(param.api, panel, true);
        }

        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < gridlist.length; i++) {
                if (EmptyPanel(gridlist[i].id, gridlist[i].type)) continue;
                if (isEmpty(GridApi(gridlist[i]))) {
                    call = false; break;
                }
            }
            //遷移表示
            if (call) callshow();
        }
    }
    function onGridReady(param, panel) {
        if (isMaterialDetailGridPanel(panel)) {
            hideMaterialGridSystemColumns(param);
            scheduleMaterialGridContentWidth(param.api, panel, true);
        }
    }

    function MaterialOrderClick() {
        openPlaceholderTab("MaterialOrder", null);  //26/7/7 Honma
    }
    // 取得した定義を元にパネル・列定義・表示状態を構築する。
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata",data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        if (code === "") {
            clearform(true);
        } else {
            // 既存データ読込前に画面を空にすると、TOP/行移動時に独自セクションや画像がちらつく。
            // データはLoadData成功時に一括差し替え、失敗時だけclearform(false)で従来同等に空状態へ戻す。
            fnc.current.modify(false);
        }
       //データ読み込み
        LoadData(code);
        return true;
    }

    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    function showpanel(id, type, show) {
        if (id === G_id.BASE && type === "0" && !show) return;
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    //行データ保持
    function storeRowData(panel) {
        if (panel === undefined) {
            for (let i = 0; i < gridlist.length; i++) {
                SetGridData(gridlist[i], AGRef.current.GetDatasource(GridApi(gridlist[i])));
            }
        } else {
            SetGridData(panel, AGRef.current.GetDatasource(GridApi(panel)));
        }
    }

    // コード+名称形式で持っている値から、素材名検索に必要なコード部分だけを取り出す。
    function normalizeMaterialCodeValue(value) {
        let text = String(value || '').trim();
        if (text === '') return '';
        text = text.replace(/：/g, ':');
        const index = text.indexOf(':');
        if (index >= 0) text = text.substring(0, index);
        return text.trim();
    }

    // s_layoutや仮想列の違いを吸収し、候補キーから素材明細の値を取得する。
    function materialRowValue(row, keys) {
        if (isEmpty(row) || !Array.isArray(keys)) return '';
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (Object.prototype.hasOwnProperty.call(row, key)) {
                return normalizeMaterialCodeValue(row[key]);
            }
            const actual = Object.keys(row).find((name) => String(name).toUpperCase() === String(key).toUpperCase());
            if (!isEmpty(actual)) return normalizeMaterialCodeValue(row[actual]);
        }
        return '';
    }

    // 文字列値をそのまま取り出したい項目用の共通取得処理。
    function materialRowTextValue(row, keys) {
        if (isEmpty(row) || !Array.isArray(keys)) return '';
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (Object.prototype.hasOwnProperty.call(row, key)) {
                return String(row[key] || '').trim();
            }
            const actual = Object.keys(row).find((name) => String(name).toUpperCase() === String(key).toUpperCase());
            if (!isEmpty(actual)) return String(row[actual] || '').trim();
        }
        return '';
    }

    function materialNormalizedColumnId(columnId) {
        let id = normalizeMdColumnId(columnId);
        if (id.endsWith('_CD')) id = id.substring(0, id.length - 3);
        return id;
    }

    function isMaterialColorSourceColumn(columnId) {
        if (isEmpty(columnId)) return false;
        const target = materialNormalizedColumnId(columnId);
        return MATERIAL_COLOR_SOURCE_COLUMNS.some((name) => materialNormalizedColumnId(name) === target);
    }

    function materialColorSelectionCode(row) {
        return materialRowValue(row, [
            "ZAIC_COLORCD",
            "ZAIC_COLORCD_cd",
            "code",
            "TNYSH_COLORNO",
            "TNYSH_COLORNO_cd",
            "TNYSH_COLORCD",
            "TNYSH_COLORCD_cd",
            "COLORCD",
            "COLORCD_cd",
            "COLOR_CODE",
            "COLORNO",
            "COLOR"
        ]);
    }

    function materialColorSelectionName(row, code) {
        const targetCode = normalizeMaterialCodeValue(code);
        const name = materialRowTextValue(row, [
            "ZAIC_COLORNM",
            "name",
            "label",
            "TNYSH_COLORNO_nm",
            "TNYSH_COLORCD_nm",
            "COLORNM",
            "COLOR_NAME"
        ]);
        if (name !== '') return name;
        if (!isEmpty(row) && targetCode !== '') {
            const fallback = materialRowTextValue(row, [
                "ZAIC_COLORCD_nm",
                "TNYSH_COLORNO",
                "TNYSH_COLORCD"
            ]);
            if (fallback !== '' && normalizeMaterialCodeValue(fallback) !== targetCode) return fallback;
        }
        return '';
    }

    function applyMaterialColorSelectionToRow(row, code, name) {
        if (isEmpty(row)) return row;
        if (code === '') {
            return {
                ...row,
                TNYSH_COLORNO: '',
                TNYSH_COLORNO_cd: '',
                TNYSH_COLORNO_nm: '',
                TNYSH_COLORCD: '',
                TNYSH_COLORCD_cd: '',
                TNYSH_COLORCD_nm: '',
                ZAIC_COLORCD: '',
                ZAIC_COLORCD_cd: '',
                ZAIC_COLORCD_nm: '',
                ZAIC_COLORNM: ''
            };
        }
        return {
            ...row,
            TNYSH_COLORNO: code,
            TNYSH_COLORNO_cd: code,
            TNYSH_COLORNO_nm: name,
            TNYSH_COLORCD: code,
            TNYSH_COLORCD_cd: code,
            TNYSH_COLORCD_nm: name,
            ZAIC_COLORCD: code,
            ZAIC_COLORCD_cd: code,
            ZAIC_COLORCD_nm: name,
            ZAIC_COLORNM: name
        };
    }

    function materialChangedColumnId(params) {
        if (isEmpty(params)) return '';
        if (!isEmpty(params.colDef) && !isEmpty(params.colDef.colinfo) && !isEmpty(params.colDef.colinfo.columnid)) {
            return params.colDef.colinfo.columnid;
        }
        if (!isEmpty(params.colDef) && !isEmpty(params.colDef.field)) return params.colDef.field;
        try {
            if (!isEmpty(params.column) && !isEmpty(params.column.getColId)) return params.column.getColId();
        } catch {
        }
        return '';
    }

    function isMaterialNameSourceColumn(columnId) {
        if (isEmpty(columnId)) return false;
        return MATERIAL_NAME_SOURCE_COLUMNS.some((name) => String(name).toUpperCase() === String(columnId).toUpperCase());
    }

    function hasGridColumn(api, columnId) {
        if (isEmpty(api) || isEmpty(columnId)) return false;
        try {
            if (!isEmpty(api.getColumnDef)) {
                return !isEmpty(api.getColumnDef(columnId));
            }
        } catch {
        }
        try {
            if (!isEmpty(api.getAllDisplayedColumns)) {
                const columns = api.getAllDisplayedColumns();
                if (Array.isArray(columns)) {
                    return columns.some((column) => {
                        if (isEmpty(column)) return false;
                        if (!isEmpty(column.getColId)) return String(column.getColId()).toUpperCase() === String(columnId).toUpperCase();
                        if (!isEmpty(column.colId)) return String(column.colId).toUpperCase() === String(columnId).toUpperCase();
                        return false;
                    });
                }
            }
        } catch {
        }
        return false;
    }

    // APIで取得した素材品名を行データと表示中のAG Gridノードの両方へ反映する。
    function setMaterialZaiName(row, api, value) {
        if (isEmpty(row)) return;
        const name = String(value || '');
        row.ZAI_NAME = name;
        try {
            if (isEmpty(api) || isEmpty(row.rowid) || isEmpty(api.getRowNode)) return;
            const node = api.getRowNode(String(row.rowid));
            if (isEmpty(node) || isEmpty(node.data)) return;
            node.data.ZAI_NAME = name;
            if (!hasGridColumn(api, 'ZAI_NAME')) return;
            node.setDataValue('ZAI_NAME', name);
        } catch {
        }
    }

    // ブランド/素材品番/仕入先が変わった時に、素材品名をMD投入表専用APIから再取得する。
    function refreshMaterialZaiName(row, api) {
        if (isEmpty(row) || isEmpty(fnc.current)) return;
        const brand = materialRowValue(row, ["TNYS_BRDCD", "TNYS_BRDCD_cd", "ZAI_BRDCODE", "ZAI_BRDCODE_cd", "BRD_CODE", "BRD_CD"]);
        const hinban = materialRowValue(row, ["TNYS_ZAIHINBAN", "TNYS_ZAIHINBAN_cd", "ZAI_HINBAN", "ZAI_HINBAN_cd"]);
        const torcd = materialRowValue(row, ["TNYS_ZAISIIRESAKICD", "TNYS_ZAISIIRESAKICD_cd", "ZAI_TORCODE", "ZAI_TORCODE_cd", "TOR_CODE", "TOR_CODE_cd"]);
        const rowKey = String(row.rowid || `${brand}\t${hinban}\t${torcd}`);
        const requestKey = `${brand}\t${hinban}\t${torcd}`;
        materialNameRequestRef.current[rowKey] = requestKey;

        if (brand === '' || hinban === '' || torcd === '') {
            setMaterialZaiName(row, api, '');
            return;
        }

        fnc.current.postaxios(
            "mdtounyu/GetMaterialZaiName",
            { brand: brand, hinban: hinban, torcd: torcd },
            {
                onSuccess: function (data) {
                    if (materialNameRequestRef.current[rowKey] !== requestKey) return;
                    const name = !isEmpty(data) && !isEmpty(data.data) ? (data.data.ZAI_NAME || '') : '';
                    setMaterialZaiName(row, api, name);
                },
                onError: function () {
                    if (materialNameRequestRef.current[rowKey] !== requestKey) return;
                    setMaterialZaiName(row, api, '');
                }
            },
            true
        );
    }

    // 共通GRIDのセル変更通知。素材明細だけ幅補正と素材品名の再取得を追加で行う。
    function handleGridValueChanged(panel, params) {
        storeRowData(panel);
        if (!isMaterialDetailGridPanel(panel)) return;

        try {
            if (!isEmpty(params) && !isEmpty(params.api)) {
                scheduleMaterialGridContentWidth(params.api, panel, true);
            }
        } catch {
        }

        const columnId = materialChangedColumnId(params);
        if (!isMaterialNameSourceColumn(columnId)) return;
        refreshMaterialZaiName(params.data, params.api);
    }

    // 複数行変更通知。貼り付け等で素材名の元項目が変わった場合も行ごとに再取得する。
    function handleMaterialRowValueChanged(panel, columnId, rows) {
        storeRowData(panel);
        if (!isMaterialDetailGridPanel(panel)) return;

        const api = GridApi(panel);
        try {
            if (!isEmpty(api)) {
                scheduleMaterialGridContentWidth(api, panel, true);
            }
        } catch {
        }

        if (!isMaterialNameSourceColumn(columnId)) return;
        (Array.isArray(rows) ? rows : []).forEach((row) => refreshMaterialZaiName(row, api));
    }

    function handleMaterialSearchResultApplied(panel, payload) {
        if (!isMaterialDetailGridPanel(panel)) return;
        const columnInfo = !isEmpty(payload) ? payload.columnInfo : null;
        const columnId = !isEmpty(columnInfo)
            ? (columnInfo.columnid || columnInfo.field || columnInfo.colId || '')
            : '';
        if (!isMaterialColorSourceColumn(columnId)) return;

        const selectedRows = Array.isArray(payload && payload.selectedRows) ? payload.selectedRows.filter((row) => !isEmpty(row)) : [];
        if (selectedRows.length === 0) return;

        const api = GridApi(panel);
        if (isEmpty(api)) return;

        const targetRowIds = [];
        const addTargetRowId = (value) => {
            const id = String(value || '').trim();
            if (id !== '' && targetRowIds.indexOf(id) === -1) targetRowIds.push(id);
        };
        if (Array.isArray(payload.sourceRowIds)) payload.sourceRowIds.forEach(addTargetRowId);
        addTargetRowId(payload.currentRowId);
        addTargetRowId(payload.rowid);

        const refreshedNodes = [];
        targetRowIds.forEach((rowId, index) => {
            if (rowId === '') return;
            const node = !isEmpty(api.getRowNode) ? api.getRowNode(String(rowId)) : null;
            if (isEmpty(node) || isEmpty(node.data)) return;

            const selected = selectedRows[index] || selectedRows[0];
            const code = materialColorSelectionCode(selected);
            if (code === '') return;
            const name = materialColorSelectionName(selected, code);
            Object.assign(node.data, applyMaterialColorSelectionToRow(node.data, code, name));
            refreshedNodes.push(node);
        });

        if (refreshedNodes.length !== 0) {
            try {
                if (!isEmpty(api.refreshCells)) {
                    api.refreshCells({ rowNodes: refreshedNodes, force: true });
                }
            } catch {
            }
            try {
                scheduleMaterialGridContentWidth(api, panel, true);
            } catch {
            }
            storeRowData(panel);
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.NB) panelid = 'remarkspanel' + type;
        if (isEmpty(type)) {
            type = tabletype(id);
        }
        if (panel.some(e => e.id === id && e.type === type && e.grid)) {
            panelid = fnc.current.GridID({ id: id, type: type });
        }
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }


    // メインコマンドの分岐処理。
    function MenuAction(action, finallycallback, selectedRows) {
        // メニュー表示時のclose通知では保存不要。GRID列状態の同期保存を避け、メニュー起動の負荷を抑える。
        if (action !== "close") {
            // コマンド実行前に現在レイアウトをローカル保存
            LayoutSaveStorage();
        }
        // 登録
        if (action === 'save') Save(finallycallback);
        // 削除
        if (action === 'delete') Delete(finallycallback);
        // クリア（新規初期化）
        if (action === "clear") clearform(true);
        // 帳票発行（RawM.jsと同じくGenerate API -> ExcelDownload）
        if (action === "print_md_tounyu" || action === "print_md_map" || action === "print_tenjikai_md_map") {
            printMdReport(action);
            return;
        }
        // エラーメッセージリンクから対象項目へフォーカス
        if (action === 'linkfield') {
            let col = textfields.find(e => e.columnid === finallycallback.field && (isEmpty(finallycallback.type)?true:e.type === finallycallback.type));
            if (col === undefined) return;
            if (col.logpid == "0") {    //基本情報
                let key = finallycallback.field + "_" + col.type;
                document.getElementById(key).focus();
                document.getElementById(key).select();
                Jump(G_id.BASE, col.type);
                return;
            }
            let logpid = col.logpid;
            Jump(logpid);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, GridApi({ id: logpid }));
        }
    }
    // 入力値収集と登録API呼び出しを実行する。
    function Save(finallycallback, nocheck) {
        // 事前チェックNGなら処理中断
        if (!canContinueSave(finallycallback, nocheck)) return;
        // 新規アップロード分のみ抽出（既存添付との差分）
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        // 画面仕様上の上限チェック
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        // グリッド編集内容を state へ確定
        storeRowData();
        // PLセクションの集計値をヘッダデータへ反映
        SetPLData();
        // 明細パネルデータを type 単位で組み立て
        var detail = {};
        for (let i = 0; i < gridlist.length; i++) {
            if (gridlist[i].id === G_id.PL) continue;
            detail[gridlist[i].type] = GridData(gridlist[i].id);
        }
        // 独自セクション（基本情報3タブ）保存用の送信データを作る。
        const currentInputBlocks = selectedInputBlocks();
        const latestTabBaseInfo = currentTabBaseInfo();
        const saveInputInfo = { ...(latestTabBaseInfo.input || {}), _INPUT_BLOCKS: currentInputBlocks };
        const saveBaseInfo = { ...(baseinfo || {}) };
        delete saveBaseInfo["0"];
        delete saveBaseInfo["100"];
        delete saveBaseInfo["101"];
        delete saveBaseInfo[BASIC_INFO_TAB_TYPE.INPUT];
        delete saveBaseInfo[BASIC_INFO_TAB_TYPE.ORDER];
        delete saveBaseInfo[BASIC_INFO_TAB_TYPE.DELIVERY];
        saveBaseInfo.input = saveInputInfo;
        saveBaseInfo.order = latestTabBaseInfo.order || {};
        saveBaseInfo.delivery = latestTabBaseInfo.delivery || {};
        // API送信用ペイロード
        const paramdata = {
            "controller": formid,
            "data": entrydataRef.current,
            "detail": detail,
            "baseinfo": saveBaseInfo,
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "code": formstatus === "COPY FORM" ? "" : edittingcode,
            "copySourceCode": formstatus === "COPY FORM" ? edittingcode : "",
            "noconfirm": nocheck
        }
        // 念のため最新編集状態を再取得
        storeRowData();
        // COPY登録は画面状態を直接変更せず、送信用データだけコピー元の投入表番号を空にする。
        if (formstatus === "COPY FORM") {
            paramdata.data = {
                ...entrydataRef.current,
                [MDTOUNYU_PRIMARY_KEY]: ""
            };
        }
        // ENTRY FORM は更新、それ以外は新規登録
        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "mdtounyu/UpdateEntry" : "mdtounyu/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    // Warningなし = 登録成功
                    if (data.warning.length === 0) {
                        // 変更フラグを落とす
                        fnc.current.modify(false);
                        let code = data.request;
                        // 新規登録時は採番コードを画面へ反映して編集モードへ移行
                        if (formstatus !== "ENTRY FORM") {
                            let pkey = primarykey();
                            if(pkey !== "")  entrydataRef.current[pkey] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        // ファイル差分がある場合は登録後にアップロード
                        if (newfiles.length !== 0) {
                            cfFileUpload("mdtounyu", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            // 通常成功メッセージ
                            fnc.current.success();
                            // 更新時は一覧へ戻すための更新行情報を返却
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();
                                finallycallback(data.data);
                            }
                            // 保存後は必ず再読込して最新サーバ状態を表示
                            LoadData(code);
                        }
                    }
                    else {
                        // Warningあり: confirm対象なら確認ダイアログを表示
                        if (isEnabled(data.confirm)) {
                            var msgs = ["内容を確認しそのまま登録する場合はOK,修正する場合はCancelを選択してください","　"];
                            for (let i = 0; i < data.warning.length; i++) {
                                msgs.push("・" + data.warning[i].message);
                            }
                            // OK時は nocheck=true で再保存
                            fnc.current.confmsg(msgs, () => Save(finallycallback, true));
                        } else {
                            // confirm対象外は詳細警告として表示
                            let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                            fnc.current.showwarndescription(msg, data.warning);
                        }
                    }
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    fnc.current.wait(false);
                    fnc.current.warnmsg(buildRegistrationWarningLines(
                        'MD投入表の登録に失敗しました。',
                        data && data.errDescription
                    ));
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        fnc.current.confmsg("MD投入表データを削除します。よろしいですか？", () => DeleteExecute(finallycallback));
    }
    function DeleteExecute(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("mdtounyu/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg([data.warning[0].message]);
                    }
                    fnc.current.wait(false);
               },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    // 投入表ヘッダ/明細/独自タブ情報を一括再読込する。
    function LoadData(code) {
        // コード未指定時は何もしない
        if (code === "") return;
        // 画面表示に必要な全データを1 APIで取得
        fnc.current.postaxios('mdtounyu/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            // 一覧側で保持しているメモ/付箋/タグを引き継ぐ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                let memo = nametocolumn("_memo");
                                if (memo !== "") {
                                    if (memo in row) data.data[memo] = row[memo];
                                }
                                let sticky = nametocolumn("_sticky");
                                if (sticky !== "") {
                                    if (sticky in row) data.data[sticky] = row[sticky];
                                }
                                let mytags = nametocolumn("_mytags");
                                if (mytags !== "") {
                                    if (mytags in row) data.data[mytags] = row[mytags];
                                }
                            }
                            // マスタ参照キャッシュを更新
                            fnc.current.margeMaster(data.master);
                            // ヘッダ項目データを差し替え
                            entrydataRef.current = data.data;
                            syncHachuMotoLock();
                            // 独自セクション（基本情報3タブ）表示用データを差し替え
                            const nextBaseInfo = data.baseinfo ? data.baseinfo : {};
                            inputBlocksStateRef.current = resolveInputBlocks(nextBaseInfo);
                            unstable_batchedUpdates(() => {
                                setbaseinfo(nextBaseInfo);
                                settabBaseInfo(resolveTabBaseInfo(nextBaseInfo));
                            });
                            // 明細グリッドデータを各パネルへ反映
                            for (let i = 0; i < gridlist.length; i++) {
                                const detailRows = data.detail ? data.detail[gridlist[i].type] : null;
                                if (detailRows !== null && detailRows !== undefined) {
                                    SetGridData({ id: gridlist[i].id }, detailRows);
                                }
                            }

                            // PL行は専用変換でセット
                            gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
                                SetGridData(l, fnc.current.PLRowData(data.data, l.type, columninfo));
                            });

                            // 添付ファイル/画像を最新化
                            fileRef.current = data.files;
                            imageRef.current = data.images;
                            dispatch(setimagelist(data.images));
                            // 再描画
                            rerender();
                        }
                        fnc.current.wait(false);
                   } catch (error) {
                        fnc.current.warnmsg("処理に失敗しました");
                        fnc.current.wait(false);
                   }
                },
                onError: function (data) {
                    clearform(false);
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data) && !isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }
    function SetPLData() {
        gridlist.filter(e => e.id === G_id.PL).forEach(function (l) {
            let column = columninfo.find(e => e.type === l.type);
            if (!isEmpty(column)) {
                entrydataRef.current[column.columnid] = fnc.current.PLTextData(GridData(l), column.columnid);
            }
        });
    }
    // MD投入表のNEW FORMだけ、年度へシステム日付の4桁年を設定する。
    function initializeMDEntryData(newform) {
        const initialData = initializedata(textfieldsall, staff);
        if (!isEnabled(newform)) return initialData;
        return {
            ...(initialData || {}),
            TNY_YEAR: String(new Date().getFullYear())
        };
    }
    //入力フィールドクリア
    function clearform(newform) {
        entrydataRef.current = initializeMDEntryData(newform);
        syncHachuMotoLock();
        inputBlocksStateRef.current = [];
        unstable_batchedUpdates(() => {
            setbaseinfo({});
            settabBaseInfo(emptyTabBaseInfo());
        });
        imageRef.current = null;
        fileRef.current = null;
        for (let i = 0; i < gridlist.length; i++) {
            SetGridData(gridlist[i], null);
        }

        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
            {
                onSuccess: function (data) {
                    for (let key in data.returnData) {
                        var col = textfieldsall.find(e => e.columnid === key);
                        if (!isEmpty(col)) col.initvalue = data.returnData[key];
                    }
                    entrydataRef.current = initializeMDEntryData(newform);
                    syncHachuMotoLock();
                    rerender();
                },
            }, true
            )
        }
    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
            if (isBottomSectionPanel(paneldata[i])) paneldata[i].hide = false;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < gridlist.length; i++) {
            AGRef.current.SaveColState(fnc.current.statusKey(gridlist[i].id, gridlist[i].type, formid), EmptyPanel(gridlist[i].id) ? null : GridColApi({id:gridlist[i].id, type:gridlist[i].type}));
        }
        //基本情報保存
        Savestorage(corpkey, account, fnc.current.statusKey(G_id.BASE, "", formid), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
        //独自セクション含む表示順
        Savestorage(corpkey, account, formid + SECTION_ORDER_STORAGE_SUFFIX, sectionOrder);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            if (panel[p].id === G_id.BASE) {
                if (setbase) break;
                let fds = textfields.filter(x => !x.hide);
                for (let f = 0; f < fds.length; f++) {
                    coldef.push({
                        headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                        type: fds[f].type
                    });
                }
                setbase = true;
            } else {
                cols = AGRef.current.GetshownColDef(GridColApi({ id: panel[p].id })); 
            }
            for (let i = 0; i < cols.length; i++) {
                let col = DeepCopy(cols[i]);
                col.type = tabletype(panel[p].id);
                coldef.push(col);
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
               },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < gridlist.length; i++) {
                        var type = gridlist[i].type;
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldef.length === 0) continue;
                        SetGridColDef({ id: gridlist[i].id, type: gridlist[i].type }, coldef);
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }

    //パネル別列情報取得
    function tabletype(id) {
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }

    //Basic Data Change
    function ValueChanged(id, value, edit) {
        //外部からの参照がある項目
        let col = Array.isArray(columninfo) ? columninfo.find(e => e.columnid === id) : null;
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
        if (isMdColumnId(id, MD_KIKAKUMOTO_FIELD_KEYS)) {
            syncHachuMotoLock({ overrideId: id, overrideValue: value, clearValue: true });
        }
    }

    // 表示対象セクションを現在の並び順で組み立てる。
    function getOrderedSectionItems() {
        const panelMap = {};
        panel.forEach(function (p) {
            panelMap[panelKeyFromItem(p)] = p;
        });

        const items = [];
        sectionOrder.forEach(function (key) {
            if (isCustomSectionKey(key)) {
                if (key === CUSTOM_SECTION_KEY_BASICINFO) {
                    items.push({ key: key, kind: "custom", name: "基本情報", title: "基本情報" });
                }
                return;
            }
            if (panelMap[key]) {
                items.push({ key: key, kind: "panel", panel: panelMap[key], name: panelMap[key].name, title: panelMap[key].name });
            }
        });
        return items;
    }
    function sectionHidden(item) {
        if (isEmpty(item)) return true;
        if (item.kind === "custom") return false;
        return panelhidden(item.panel);
    }
    function jumpSection(item) {
        if (isEmpty(item)) return;
        if (item.kind === "custom") {
            const elem = document.getElementById(CUSTOM_SECTION_DOM_ID[item.key]);
            if (isEmpty(elem)) return;
            EntrybodyRef.current.scrollTop = elem.offsetTop - 50;
            return;
        }
        Jump(item.panel.id, item.panel.type);
    }
    function moveOrderByVisibleIndices(order, visibleItems, oldIndex, newIndex) {
        const fromKey = visibleItems[oldIndex]?.key;
        const toKey = visibleItems[newIndex]?.key;
        if (isEmpty(fromKey) || isEmpty(toKey) || fromKey === toKey) return order;
        const work = order.filter(function (key) { return key !== fromKey; });
        const target = work.indexOf(toKey);
        const insert = oldIndex < newIndex ? target + 1 : target;
        work.splice(insert, 0, fromKey);
        return work;
    }
    function renderPendingOrderLaunchDialog() {
        if (pendingOrderLaunches.length === 0) return null;
        const dialogStyle = {
            position: "fixed",
            inset: 0,
            zIndex: 4100,
            backgroundColor: "rgba(0,0,0,0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16
        };
        const paperStyle = {
            width: "min(520px, 96vw)",
            maxHeight: "90vh",
            overflow: "auto",
            padding: 20
        };
        const footerStyle = { display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 16 };
        return (
            <div style={dialogStyle} onClick={() => setPendingOrderLaunches([])}>
                <Paper elevation={3} style={paperStyle} onClick={(e) => e.stopPropagation()}>
                    <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>残りの起動対象</div>
                    <div style={{ fontSize: 12, color: "#444", marginBottom: 12 }}>
                        ブラウザ制限のため、自動で複数タブを同時に開けません。残りは 1 件ずつ開いてください。
                    </div>
                    <div style={{ display: "grid", gap: 8 }}>
                        {pendingOrderLaunches.map((item) => (
                            <div key={"pending_order_" + item.index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, border: "1px solid #d9d9d9", borderRadius: 4, padding: "8px 10px" }}>
                                <span style={{ fontSize: 12 }}>{pendingOrderLaunchLabel(item)}</span>
                                <Button size="small" variant="contained" color="primary" onClick={() => openPendingOrderLaunch(item)}>開く</Button>
                            </div>
                        ))}
                    </div>
                    <div style={footerStyle}>
                        <Button size="small" onClick={() => setPendingOrderLaunches([])}>閉じる</Button>
                    </div>
                </Paper>
            </div>
        );
    }

    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        if (oldIndex === newIndex) return;
        const visibleItems = getOrderedSectionItems().filter(function (item) { return !sectionHidden(item); });
        const nextOrder = moveOrderByVisibleIndices(sectionOrder, visibleItems, oldIndex, newIndex);
        setsectionOrder(nextOrder);
        setpanel(reorderPanelsBySectionOrder(panel, nextOrder));
    };

    //パネルセレクタ
    const SortablePanelItem = SortableElement(({ section }) => (
        <ListItem className="minwidth0">
            <Chip
                label={section.name}
                title={section.title}
                size="small"
                onClick={() => jumpSection(section)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ sections }) => {
        const visibleSections = sections.filter(function (section) { return !sectionHidden(section); });
        return (
            <ul style={{ display: 'flex', margin: 0, padding: 0, alignItems: 'center' }}  >
                {visibleSections.map((value, index) => (
                    <SortablePanelItem key={`item-${value.key}`} index={index} section={value} />
                ))}
            </ul>
        );
    });

    const mdtounyuhyoHandlerRef = useRef({
        onAddExists: addExistsClick,
        onAddNew: addNewClick,
        onProductOrder: productOrderClick,
        onSubMaterial: subMaterialClick,
        onUnlink: unlinkBlockClick,
        onToggleStop: stopFlagToggleClick,
        onInputBlocksChange: updateInputBlocksState,
        onApplyInput: applyInputQtyClick
    });
    useEffect(() => {
        mdtounyuhyoHandlerRef.current = {
            onAddExists: addExistsClick,
            onAddNew: addNewClick,
            onProductOrder: productOrderClick,
            onSubMaterial: subMaterialClick,
            onUnlink: unlinkBlockClick,
            onToggleStop: stopFlagToggleClick,
            onInputBlocksChange: updateInputBlocksState,
            onApplyInput: applyInputQtyClick
        };
    }, [addExistsClick, addNewClick, productOrderClick, subMaterialClick, unlinkBlockClick, stopFlagToggleClick, updateInputBlocksState, applyInputQtyClick]);

    const onMdtounyuhyoAddExists = useCallback((blocks) => mdtounyuhyoHandlerRef.current.onAddExists(blocks), []);
    const onMdtounyuhyoAddNew = useCallback(() => mdtounyuhyoHandlerRef.current.onAddNew(), []);
    const onMdtounyuhyoProductOrder = useCallback((blocks) => mdtounyuhyoHandlerRef.current.onProductOrder(blocks), []);
    const onMdtounyuhyoSubMaterial = useCallback((blocks) => mdtounyuhyoHandlerRef.current.onSubMaterial(blocks), []);
    const onMdtounyuhyoUnlink = useCallback((blockData) => mdtounyuhyoHandlerRef.current.onUnlink(blockData), []);
    const onMdtounyuhyoToggleStop = useCallback((blockData, checked) => mdtounyuhyoHandlerRef.current.onToggleStop(blockData, checked), []);
    const onMdtounyuhyoInputBlocksChange = useCallback((nextBlocks, updateView) => mdtounyuhyoHandlerRef.current.onInputBlocksChange(nextBlocks, updateView), []);
    const onMdtounyuhyoApplyInput = useCallback((cards) => mdtounyuhyoHandlerRef.current.onApplyInput(cards), []);

    const mdTounyuJutakuHinFlg = String((entrydataRef.current && entrydataRef.current.TNY_JUTAKUHINFLG) || '').trim();
    const mdtounyuhyoProps = useMemo(() => ({
        tabBaseInfo: currentTabBaseInfo(),
        themeStyle: themeStyle,
        fnc: fnc,
        jutakuHinFlg: mdTounyuJutakuHinFlg,
        activeTab: basicInfoTab,
        onChangeTab: setbasicInfoTab,
        onAddExists: onMdtounyuhyoAddExists,
        onAddNew: onMdtounyuhyoAddNew,
        onProductOrder: onMdtounyuhyoProductOrder,
        onSubMaterial: onMdtounyuhyoSubMaterial,
        onUnlink: onMdtounyuhyoUnlink,
        onToggleStop: onMdtounyuhyoToggleStop,
        onInputBlocksChange: onMdtounyuhyoInputBlocksChange,
        onApplyInput: onMdtounyuhyoApplyInput,
        // NEW/ENTRYを問わず、発注済みカードは確定フラグ以外を編集不可にする。
        lockIssuedData: true,
        commandsDisabled: formstatus === 'NEW FORM'
    }), [
        tabBaseInfo,
        themeStyle,
        fnc,
        mdTounyuJutakuHinFlg,
        basicInfoTab,
        onMdtounyuhyoAddExists,
        onMdtounyuhyoAddNew,
        onMdtounyuhyoProductOrder,
        onMdtounyuhyoSubMaterial,
        onMdtounyuhyoUnlink,
        onMdtounyuhyoToggleStop,
        onMdtounyuhyoInputBlocksChange,
        onMdtounyuhyoApplyInput,
        formstatus
    ]);

    // パネル種別ごとに表示コンポーネントを切り替える。
    function Contents(props) {
        if (props.panel.id === G_id.BASE) {
            const baseid = "basepanel" + props.panel.type;
            if (props.panel.type === "0") {
                return null;
            }
            if (isBasicInfoPanelType(props.panel.type)) return null;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={effectiveTextfields}
                        settextfields={lockIssuedEntryData ? () => {} : settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock || lockIssuedEntryData}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.grid) {
            const isMaterialGrid = isMaterialDetailGridPanel(props.panel);
            const grid = (
                <EntryGridAr
                    id={fnc.current.GridID(props.panel)}
                    entrydataRef={entrydataRef}
                    dataRef={griddataRefs.current[fnc.current.gridindex(props.panel)]}
                    columnRef={gridcolRefs.current[fnc.current.gridindex(props.panel)]}
                    columninfo={columninfo}
                    columns={columns}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    formid={formid}
                    ValueChanged={(params) => handleGridValueChanged(props.panel, params)}
                    RowValueChanged={isMaterialGrid ? (columnId, rows) => handleMaterialRowValueChanged(props.panel, columnId, rows) : undefined}
                    SearchResultApplied={isMaterialGrid ? (payload) => handleMaterialSearchResultApplied(props.panel, payload) : undefined}
                    panel={props.panel}
                    rowDrag={isMaterialGrid ? false : undefined}
                    rowDragManaged={isMaterialGrid ? false : undefined}
                    QuerySetColumn={isMaterialGrid ? MaterialGridQuerySetColumn : undefined}
                />
            );
            if (isMaterialGrid) {
                return <div className={MATERIAL_GRID_CLASS}>{grid}</div>;
            }
            return grid;
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.NB) {
            if (isEmpty(columninfo)) return null;
            let coldef = columninfo.find(e => e.type === props.panel.type);
            return (
                <EntryRemarks
                    id={"remarkspanel" + props.panel.type}
                    def={coldef}
                    dataRef={entrydataRef}
                    fnc={fnc}
                    ValueChanged={ValueChanged}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE) {
                if (type === "0") return true;
                if (isBasicInfoPanelType(type)) return true;
                return isEmpty(textfields.find(e => e.type === type));
            }
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    // 表示条件（定義有無/データ有無/固定非表示）でパネルを判定する。
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (isBottomSectionPanel(p)) return true;
        if (p.id === G_id.BASE && p.type === "0") return true;
        if (p.id === G_id.BASE && isBasicInfoPanelType(p.type) && p.type !== "0") return true;
        if (p.id === G_id.IMAGE) {
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    // メニュー開閉などMD本体の表示内容に関係しない親再描画では、重い入力フォーム本体を再生成しない。
    const entryContentVersion = useMemo(() => ({}), [
        panel,
        sectionOrder,
        layoutlock,
        sectionclose,
        textfields,
        effectiveTextfields,
        columns,
        columninfo,
        edittingcode,
        update,
        entrylock,
        gridlist,
        mdtounyuhyoProps
    ]);
    const visibleEntrySections = useMemo(
        () => getOrderedSectionItems().filter(function (section) { return !sectionHidden(section); }),
        [entryContentVersion]
    );
    const renderEntrySection = useCallback((section) => {
        if (section.kind === "custom" && section.key === CUSTOM_SECTION_KEY_BASICINFO) {
            return (
                <Box
                    key={section.key}
                    id={CUSTOM_SECTION_DOM_ID[section.key]}
                    display={"flex"}
                    justifyContent="space-around"
                    alignItems="center"
                    padding="5px"
                >
                    <Paper
                        style={{
                            width: '100%',
                            height: 'auto',
                            padding: 10
                        }}
                    >
                        <MDtounyuhyo {...mdtounyuhyoProps} />
                    </Paper>
                </Box>
            );
        }
        const p = section.panel;
        return (
            <Box
                key={section.key}
                display={"flex"}
                justifyContent="space-around"
                alignItems="center"
                padding="5px"
            >
                <Paper
                    style={{
                        width: '100%',
                        height: 'auto',
                        padding: 10
                    }}
                >
                    {isMaterialDetailGridPanel(p) ? (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 12,
                                marginBottom: 10,
                                minHeight: 28
                            }}
                        >
                            <span>
                                {getMaterialPanelTitle(p)}
                            </span>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
                                <Button
                                    size="small"
                                    variant="contained"
                                    disabled={formstatus === 'NEW FORM'}
                                    onClick={MaterialOrderClick}
                                    style={{
                                        minWidth: 106,
                                        height: 24,
                                        padding: '0 14px',
                                        borderRadius: 4,
                                        backgroundColor: formstatus === 'NEW FORM' ? '#bdbdbd' : '#4CAF50',
                                        color: '#FFFFFF',
                                        boxShadow: 'none',
                                        fontSize: 12,
                                        fontWeight: 700,
                                        lineHeight: '24px'
                                    }}
                                >
                                    原材料発注
                                </Button>
                                {layoutlock || sectionclose || isBottomSectionPanel(p) ? null :
                                    <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}>
                                        <Icon style={{ fontSize: 16 }}>close</Icon>
                                    </IconButton>
                                }
                            </div>
                        </div>
                    ) : (
                        <div style={{ position: 'relative', marginBottom: 5 }}>
                            {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                            {p.id !== '0' || layoutlock || isBasicInfoPanelType(p.type) ? null :
                                <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                    <IconButton size="small" onClick={() => SetBaseField(p.type)}  >
                                        <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                    </IconButton>
                                </div>
                            }
                            {layoutlock || sectionclose || isBottomSectionPanel(p) ? null :
                                <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                    <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                        <Icon style={{ fontSize: 16 }}>close</Icon>
                                    </IconButton>
                                </div>
                            }
                        </div>
                    )}
                    <Contents panel={p} />
                </Paper >
            </Box>
        );
    }, [entryContentVersion]);
    const entryFormContent = useMemo(() => (
        <EntryFormContent
            entryBodyRef={EntrybodyRef}
            onDragEnter={onDragEnter}
            sections={visibleEntrySections}
            renderSection={renderEntrySection}
        />
    ), [visibleEntrySections, renderEntrySection]);

    return (
        <div className={MDTOUNYU_ROOT_CLASS}>
            <style>{MATERIAL_GRID_STYLE}</style>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                entryform={true}
                tabs={true}
                show={Show}
                primarykey={primarykeys}
                entrydataRef={entrydataRef}
                navmenu={entrylock ? navmenu.filter(e => e.menuid !== 'formupload') : navmenu}
                suppressaction={suppressaction}
                lockcell={ListlockCell}
                usecondition={true}
           >
            <MemoizedEntryForm content={entryFormContent} />
            </MasterBase>
            {renderPendingOrderLaunchDialog()}
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={() => fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210, display: 'flex', alignItems: 'center', gap: 8, minHeight: 30 }}>
                        <Paper
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0,
                                m: 0,
                            }}
                            component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: 'auto', minWidth: 0 }}
                        >
                                {/*Panel Selector*/}
                                <SortablePanelSelector
                                    axis={"x"}
                                    sections={getOrderedSectionItems()}
                                    onSortEnd={onPanelSortEnd}
                                    distance={2}
                                 />
                        </Paper>
                        <Button
                            variant="contained"
                            size="small"
                            disableElevation
                            style={{
                                backgroundColor: '#4caf50',
                                color: '#fff',
                                minWidth: 64,
                                minHeight: 28,
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                                textTransform: 'none',
                                fontWeight: 700
                            }}
                            onClick={chatButtonClick}
                        >
                            チャット
                        </Button>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <MDtounyuHinbanDialog
                open={hinbanDialogOpen}
                initialValues={hinbanDialogInitialValues}
                mdTounyuNo={edittingcode}
                fnc={fnc}
                onClose={closeHinbanDialog}
                onRegisterSuccess={handleHinbanRegisterSuccess}
            />
        {/*    <DropZone*/}
        {/*        controller={controller}*/}
        {/*        code={edittingcode}*/}
        {/*        open={isDragActive}*/}
        {/*        onclose={FileDropClose}*/}
        {/*        actionurl={actionurl}*/}
        {/*        uploaded={fileuploaded}*/}
        {/*    />*/}
        </div>
    );
};
